import { get_session9cytjmfbg8nd as get_session } from '../../../../../sdk/UserSession.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
  awaitOnce2ui7qqi9bvdeq as awaitOnce,
} from '../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  PayApplicationmbkdcq3ut87x as PayApplication,
  PayAppItemz8p3l02jgtr9 as PayAppItem,
  Projecto73xqbcrzskm as Project,
  LineItem2rt64afaiyloc as LineItem,
  ItemChangee3c665suy3yz as ItemChange,
  ScopeView2pjeasrtqdymw as ScopeView,
} from '../../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_project8eilj2kht5hl as get_project,
  get_descriptionv6nk17rgbaxj as get_description,
} from '../../../../../../../../crowpay-shared/com/crowpay/PayApplicationFields.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  CreationError2yp65thg4sfbo as CreationError,
  NotFoundikk4a5uq9edp as NotFound,
} from '../../../../../sdk/errors.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  LineItemState_InProgress_getInstance30c0b4tuqukui as LineItemState_InProgress_getInstance,
  LineItemState_KeepWorking_getInstanceieb6rws75lm1 as LineItemState_KeepWorking_getInstance,
  LineItemState_Cancelled_getInstance3kcyrqker8w6h as LineItemState_Cancelled_getInstance,
  MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance,
} from '../../../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope284yy3flyb2v2 as coroutineScope,
} from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { minus165a8u1e0x1lu as minus } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import {
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
} from '../../../nav/crowpay.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  MonetaryValue__times_impl_hlr6p72nff9ykdm2zvo as MonetaryValue__times_impl_hlr6p7,
  get_shortDisplayNamenwyz2dxtvf5g as get_shortDisplayName,
  HasDisplayName3s4kfsms5h38b as HasDisplayName,
} from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { ModificationBuilderuhgnvnxpchbi as ModificationBuilder } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ModificationBuilder.mjs';
import {
  get_amount297a4togm1x48 as get_amount,
  get_project2kz1aoxt3unwl as get_project_0,
} from '../../../../../../../../crowpay-shared/com/crowpay/PayAppItemFields.mjs';
import { printStackTrace214c8iyv3cpiv5 as printStackTrace2 } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/debugger.js.mjs';
import { ConnectionException1wjs7wwnknnfm as ConnectionException } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/fetch.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_dp28ag147e4p5cz as get_dp,
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
  plus2opbwe063z9pg as plus,
  get_px8ok5q0jdway2 as get_px,
  minus1paei8txflgx9 as minus_0,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_atBottomStart155elrlt6jm53 as get_atBottomStart,
  get_atBottomCenterphs4xo2ro2dv as get_atBottomCenter,
  forEach37zw770vd3h4l as forEach,
  get_expanding10cuv3ua9vajx as get_expanding,
  get_atEnd1cw5d2zgug26 as get_atEnd,
  get_atCenterStart2eaw4isrpvpjb as get_atCenterStart,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  bodyBold2czwdzwknab0k as bodyBold,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  body3i5t0n7zprpqb as body,
  title1ahgushtajx2d as title,
  title1nssp3ryhwuqj as title_0,
  smallBody2trfy14zwtona as smallBody,
} from '../../../../theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  percentComplete22ixcedvdan2 as percentComplete,
  renderPercent3ullukkakwyrl as renderPercent,
  zeroToNull11q39tqjxlqyg as zeroToNull,
  Action1a4ymn5nx79hk as Action,
  resize3py5p2yrjp6p7 as resize,
} from '../../../../../utils/utils.mjs';
import {
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance,
  ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance,
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  ListSemantic_getInstance1hx6c2zatma42 as ListSemantic_getInstance,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  validate1c6autp3a2bus as validate,
  validateReactive1mjr7u7b9jd4s as validateReactive,
} from '../../../../../utils/validation.mjs';
import {
  Companion_instance2rgq1hlpwff0j as Companion_instance_0,
  Platform_Web_getInstanceu4ctcncq1n0 as Platform_Web_getInstance,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { MonetaryValueInput2lk8s753hzo22 as MonetaryValueInput } from '../../../MonetaryValueInput.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { resolveProjectAttachments1r3ylk2p3xmwv as resolveProjectAttachments } from '../../../files/attachmentFilePreview.mjs';
import {
  confirmationDialog1lynowl7yd4cd as confirmationDialog,
  GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog,
} from '../../../../dialogs/GenericConfirmationDialog.mjs';
import { modify2eca96i8s7hc2 as modify } from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { pushChanges1lnw8bjwewvzf as pushChanges } from '../../../../../utils/Draft.ext.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { delayolwo40i9ucjz as delay } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../nav/AppDimensions.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  timesx4ey3un7ihw1 as times,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
  Align_Stretch_getInstancecei5ndh62f1w as Align_Stretch_getInstance,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  listOfvhqybd2zx248 as listOf,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  get_lightSection4cpu8okr0w14 as get_lightSection,
  LightSection_getInstance1p9fz392synu9 as LightSection_getInstance,
  get_section1qyzr1npzel2z as get_section,
} from '../../../../theming/sections.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { lensPath16mstx1fbm6dz as lensPath } from '../../../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import {
  errorTextv58wi1t0me7u as errorText,
  icon1sxjaie5w1apt as icon,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { fileManager1pvd5zvbyt8nt as fileManager } from '../../../files/fileManager.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  align1ejncrrer3meh as align,
  weightt34o7llf2uyq as weight,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { NotificationBarSemanticwa6jjp0en36y as NotificationBarSemantic } from '../../../../theming/banners.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../../theming/AppColors.mjs';
import {
  dynamicThemexp3sdnaolntz as dynamicTheme,
  get_compact3lsezez8nz8b6 as get_compact,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  Formats_getInstance5hp5sczkglnx as Formats_getInstance,
  format1crnfsffhjur0 as format,
} from '../../../../../../../../crowpay-shared/com/crowpay/timeFormatting.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../../../theming/separators.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  coerceAtMost31oazapy1u82u as coerceAtMost,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  Collection1k04j3hzsbod0 as Collection,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { toList2zksu85ukrmi as toList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Maps.mjs';
import {
  sortedWith2csnbbb21k0lg as sortedWith,
  toSet2orjxp16sotqu as toSet,
  drop3na99dw9feawf as drop,
  sum3e7yagmfz1l7l as sum,
  plus310ted5e4i90h as plus_0,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  scopeSetIcon1d64me82i5zfn as scopeSetIcon,
  infoBubblebw7xb14ivkdr as infoBubble,
} from '../../../iconShortcuts.mjs';
import { trackWeights2d4yjn3jzod5x as trackWeights } from '../../../../../utils/tables/ColumnWeights.mjs';
import { colored3y8uibz1hk46 as colored } from '../../../../theming/colorManagement.mjs';
import {
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_padded3m3frjnjujncx as get_padded,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { InnerTabBar_getInstance20l55y0u7bopn as InnerTabBar_getInstance } from '../../../../theming/tabs.mjs';
import { RadioToggleButton6jdt9lqh3p8p as RadioToggleButton } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/RadioToggleButton.commonHtml.mjs';
import {
  equalTo2dio0vrcsd3je as equalTo,
  contains3hkd7li7hrfjb as contains,
} from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import {
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  RemoveToggleSemantic_getInstancet61nqekdjv1v as RemoveToggleSemantic_getInstance,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText33v0vmsdeuehr as specCenteredText_0,
  get_deleteButton1v46c8rhktdg5 as get_deleteButton,
  DangerButtonSemantic_getInstanceb7gofax87736 as DangerButtonSemantic_getInstance,
} from '../../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { MutableRememberyv35kz5kmml7 as MutableRemember } from '../../../../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import {
  RemoveOutline_getInstance2r2ekg5cxorga as RemoveOutline_getInstance,
  get_redText11s08hp3hs1x3 as get_redText,
} from '../../../../theming/appTheme.mjs';
import { ToggleButton22qnd3p3jsqqx as ToggleButton } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ToggleButton.commonHtml.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import {
  isPendingCompletion65tdr7y6lgp6 as isPendingCompletion,
  isComplete3isyniin1qz2u as isComplete,
  displayState3v4rl6ol8mfdu as displayState,
} from '../../../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import { validated3dw9xce8adqbh as validated } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import { validateus3ow1e5uncs as validate_0 } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import {
  get_increasedProjectPricecnanfo88a7j2 as get_increasedProjectPrice,
  AdjustedLineItemjcq04uf63gb9 as AdjustedLineItem,
} from '../../../../../utils/AdjustedLineItem.mjs';
import { leftExpandButton23soimuuf6gel as leftExpandButton } from '../../../expansion.mjs';
import {
  tableEntryUnderlinedString3hj244dg60e1r as tableEntryUnderlinedString,
  tableEntryUnderlinedString1xi3bqljwfn1f as tableEntryUnderlinedString_0,
} from '../../../keyValue.mjs';
import { GreyedOutSemantic_getInstancexltt5xem3a07 as GreyedOutSemantic_getInstance } from '../../../../theming/states.mjs';
import { get_trash3qsdn4kaynjmu as get_trash } from '../../../../../icons.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { IssueNode2x8c6ia7dmfdz as IssueNode } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/IssueNode.mjs';
import { Draftj5auffrm1u2b as Draft } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { validated2q9ie09qg9r46 as validated_0 } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import { get_project15zbqkhtwq5i6 as get_project_1 } from '../../../../../../../../crowpay-shared/com/crowpay/LineItemFields.mjs';
import { get_project1h3ocr37wkxs4 as get_project_2 } from '../../../../../../../../crowpay-shared/com/crowpay/ItemChangeFields.mjs';
import { get_project2bky694b9ef47 as get_project_3 } from '../../../../../../../../crowpay-shared/com/crowpay/ScopeViewFields.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import {
  get_status1qu684t7g7eh as get_status,
  PayAppStatus_Voided_getInstance1gkfpgvkvjp6x as PayAppStatus_Voided_getInstance,
  PayAppStatus_Denied_getInstance3qemqfv8kyvuv as PayAppStatus_Denied_getInstance,
} from './data.mjs';
import { toFileData1whrjalotozwt as toFileData } from '../../../../../extensions/ProjectAttachment.ext.mjs';
import { LandingScreennv9edtrim3be as LandingScreen } from '../../../../screens/common/LandingScreen.mjs';
import {
  get_awaitingApprovalMessagemcfmnhjri98l as get_awaitingApprovalMessage,
  renderFinishRegistrationbdw1wx3e9bul as renderFinishRegistration,
  renderAwaitingApprovalsh6ugtdyt2je as renderAwaitingApproval,
  render2bonfr4ls49sc as render,
  ContractorPage2yk275fy06uv3 as ContractorPage,
} from '../../../../screens/contractor/IsContractorScreen.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_CreatePayApp__w9fmkz(project, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  // Inline function 'com.lightningkite.lightningdb.Query' call
  // Inline function 'kotlin.collections.listOf' call
  var orderBy = emptyList();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(PayApplication()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$2);
  var tmp$ret$4 = eq(get_project(it), project);
  var tmp$ret$5 = new (Query())(tmp$ret$4, orderBy, 0, 100);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = session.afw_1.feo(tmp$ret$5);
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var numPayApps = tmp_1.p1();
  var tmp_2 = session.afw_1.mft(new (PayApplication())(VOID, project, numPayApps + 1 | 0), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = tmp_2;
  var tmp_3 = await_0(this_2, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp0_elvis_lhs = tmp_3;
  var tmp_4;
  if (tmp0_elvis_lhs == null) {
    throw CreationError().cfy(getKClass(PayApplication()));
  } else {
    tmp_4 = tmp0_elvis_lhs;
  }
  var new_0 = tmp_4;
  return new (PayAppForm())(new_0.i6y_1);
}
function CreatePayApp(project, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_CreatePayApp__w9fmkz.bind(VOID, project), $completion);
}
function drawable(_this__u8e3s4) {
  return _this__u8e3s4.equals(LineItemState_InProgress_getInstance()) || _this__u8e3s4.equals(LineItemState_KeepWorking_getInstance());
}
var Section_Summary_instance;
var Section_Draws_instance;
function values() {
  return [Section_Summary_getInstance(), Section_Draws_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var Section_entriesInitialized;
function Section_initEntries() {
  if (Section_entriesInitialized)
    return Unit_instance;
  Section_entriesInitialized = true;
  Section_Summary_instance = Section().jhg('Summary', 0, 'Summary');
  Section_Draws_instance = Section().jhg('Draws', 1, 'Draws');
}
var $ENTRIES;
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = $this.khg_1.jh7(true, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$coroutineScope, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.xhg_1.wf4_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if ($this.yhg_1.t1(element.mhg_1.kf9_1)) {
      destination.v(element);
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = destination.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    launch($this$coroutineScope, VOID, VOID, PayAppForm$SelectItemsDialog$render$slambda$slambda$slambda_0(element_0));
  }
  return Unit_instance;
}
var PayAppForm$SelectItemsDialog$render$slambda$slambda$slambdaClass;
function PayAppForm$SelectItemsDialog$render$slambda$slambda$slambda() {
  if (PayAppForm$SelectItemsDialog$render$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($it) {
        this.khg_1 = $it;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    PayAppForm$SelectItemsDialog$render$slambda$slambda$slambdaClass = $;
  }
  return PayAppForm$SelectItemsDialog$render$slambda$slambda$slambdaClass;
}
function PayAppForm$SelectItemsDialog$render$slambda$slambda$slambda_0($it) {
  var i = new (PayAppForm$SelectItemsDialog$render$slambda$slambda$slambda())($it);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  var tmp = $this.zhg_1.bhh($this.ahh_1.pf4_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $this$coroutineScope, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.chh_1.vf4_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if ($this.dhh_1.t1(element.mhg_1.kf9_1)) {
      destination.v(element);
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = destination.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    launch($this$coroutineScope, VOID, VOID, PayAppForm$SelectItemsDialog$render$slambda$slambda$slambda_2(element_0, $this.chh_1));
  }
  return Unit_instance;
}
var PayAppForm$SelectItemsDialog$render$slambda$slambda$slambdaClass_0;
function PayAppForm$SelectItemsDialog$render$slambda$slambda$slambda_1() {
  if (PayAppForm$SelectItemsDialog$render$slambda$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($it, this$0) {
        this.zhg_1 = $it;
        this.ahh_1 = this$0;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    PayAppForm$SelectItemsDialog$render$slambda$slambda$slambdaClass_0 = $;
  }
  return PayAppForm$SelectItemsDialog$render$slambda$slambda$slambdaClass_0;
}
function PayAppForm$SelectItemsDialog$render$slambda$slambda$slambda_2($it, this$0) {
  var i = new (PayAppForm$SelectItemsDialog$render$slambda$slambda$slambda_1())($it, this$0);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ihh_1.fhh_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var selected = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.ihh_1.ehh_1;
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var previouslySelected = tmp_0;
  var added = minus(selected, previouslySelected);
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!added.i1()) {
    var tmp_1 = coroutineScope(PayAppForm$SelectItemsDialog$render$slambda$slambda_0($this.jhh_1, added), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  var removed = minus(previouslySelected, selected);
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!removed.i1()) {
    var tmp_2 = coroutineScope(PayAppForm$SelectItemsDialog$render$slambda$slambda_2($this.jhh_1, removed), $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  get_dialogStack().ngd();
  return Unit_instance;
}
var PayAppForm$SelectItemsDialog$render$slambda$slambdaClass;
function PayAppForm$SelectItemsDialog$render$slambda$slambda() {
  if (PayAppForm$SelectItemsDialog$render$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $added) {
        this.xhg_1 = this$0;
        this.yhg_1 = $added;
      }
      wah($this$coroutineScope, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$coroutineScope), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    PayAppForm$SelectItemsDialog$render$slambda$slambdaClass = $;
  }
  return PayAppForm$SelectItemsDialog$render$slambda$slambdaClass;
}
function PayAppForm$SelectItemsDialog$render$slambda$slambda_0(this$0, $added) {
  var i = new (PayAppForm$SelectItemsDialog$render$slambda$slambda())(this$0, $added);
  var l = ($this$coroutineScope, $completion) => i.wah($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
var PayAppForm$SelectItemsDialog$render$slambda$slambdaClass_0;
function PayAppForm$SelectItemsDialog$render$slambda$slambda_1() {
  if (PayAppForm$SelectItemsDialog$render$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $removed) {
        this.chh_1 = this$0;
        this.dhh_1 = $removed;
      }
      wah($this$coroutineScope, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$coroutineScope), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    PayAppForm$SelectItemsDialog$render$slambda$slambdaClass_0 = $;
  }
  return PayAppForm$SelectItemsDialog$render$slambda$slambdaClass_0;
}
function PayAppForm$SelectItemsDialog$render$slambda$slambda_2(this$0, $removed) {
  var i = new (PayAppForm$SelectItemsDialog$render$slambda$slambda_1())(this$0, $removed);
  var l = ($this$coroutineScope, $completion) => i.wah($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.khh_1 = function_0;
      }
      wi(a, b) {
        return this.khh_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.khh_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function PayAppForm$SelectItemsDialog$groupedForms$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp0_safe_receiver = a.af_1;
  var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o7z_1;
  var tmp0_safe_receiver_0 = b.af_1;
  var tmp$ret$1 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.o7z_1;
  return compareValues(tmp, tmp$ret$1);
}
var PayAppForm$SelectItemsDialog$render$slambdaClass;
function PayAppForm$SelectItemsDialog$render$slambda() {
  if (PayAppForm$SelectItemsDialog$render$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    PayAppForm$SelectItemsDialog$render$slambdaClass = $;
  }
  return PayAppForm$SelectItemsDialog$render$slambdaClass;
}
function PayAppForm$SelectItemsDialog$render$slambda_0() {
  var i = new (PayAppForm$SelectItemsDialog$render$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var PayAppForm$SelectItemsDialog$render$slambdaClass_0;
function PayAppForm$SelectItemsDialog$render$slambda_1() {
  if (PayAppForm$SelectItemsDialog$render$slambdaClass_0 === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    PayAppForm$SelectItemsDialog$render$slambdaClass_0 = $;
  }
  return PayAppForm$SelectItemsDialog$render$slambdaClass_0;
}
function PayAppForm$SelectItemsDialog$render$slambda_2() {
  var i = new (PayAppForm$SelectItemsDialog$render$slambda_1())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var PayAppForm$SelectItemsDialog$render$slambdaClass_1;
function PayAppForm$SelectItemsDialog$render$slambda_3() {
  if (PayAppForm$SelectItemsDialog$render$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0, this$1) {
        this.ihh_1 = this$0;
        this.jhh_1 = this$1;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    PayAppForm$SelectItemsDialog$render$slambdaClass_1 = $;
  }
  return PayAppForm$SelectItemsDialog$render$slambdaClass_1;
}
function PayAppForm$SelectItemsDialog$render$slambda_4(this$0, this$1) {
  var i = new (PayAppForm$SelectItemsDialog$render$slambda_3())(this$0, this$1);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_save__qhzefp($this, saveIfNull, $completion) {
  var tmp0_elvis_lhs = $this.lhg_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var payItem = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.uhg_1;
  var tmp_0 = await_1(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0;
  var tmp1_elvis_lhs = tmp_1 == null ? null : tmp_1.a5s_1;
  var tmp_2;
  var tmp_3 = tmp1_elvis_lhs;
  if ((tmp_3 == null ? null : new (MonetaryValue())(tmp_3)) == null) {
    var tmp_4;
    if (saveIfNull) {
      tmp_4 = Companion_instance.p91(0n);
    } else {
      return Unit_instance;
    }
    tmp_2 = tmp_4;
  } else {
    tmp_2 = tmp1_elvis_lhs;
  }
  var amount = tmp_2;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp_5 = await_0(this_1, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  // Inline function 'kotlin.run' call
  var $this$run = tmp_5.bfw_1;
  var model = $this$run.kft(payItem.q6v_1);
  var tmp_6;
  var tmp_7 = awaitOnce(model, $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  if (!(tmp_7 == null)) {
    // Inline function 'com.crowpay.utils.modify2' call
    // Inline function 'com.lightningkite.lightningdb.modification' call
    // Inline function 'kotlin.apply' call
    var this_2 = new (ModificationBuilder())();
    // Inline function 'com.lightningkite.lightningdb.path' call
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_8 = serializerOrContextual(createKType(getKClass(PayAppItem()), arrayOf([]), false));
    var tmp$ret$2 = isInterface(tmp_8, KSerializer()) ? tmp_8 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$2);
    this_2.e44(get_amount(it), new (MonetaryValue())(amount));
    var tmp$ret$7 = this_2.o1r();
    var tmp_9 = model.len(tmp$ret$7, $completion);
    if (tmp_9 === get_COROUTINE_SUSPENDED())
      tmp_9 = yield tmp_9;
    tmp_6 = tmp_9;
  } else {
    var tmp_10 = $this$run.mft(payItem.d6w(VOID, VOID, VOID, amount), $completion);
    if (tmp_10 === get_COROUTINE_SUSPENDED())
      tmp_10 = yield tmp_10;
    tmp_6 = tmp_10;
  }
  return Unit_instance;
}
function *_generator_delete__spiywt($this, cache, $completion) {
  if ($this.lhg_1 == null)
    return Unit_instance;
  try {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_session();
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp_0 = tmp.bfw_1.kft($this.lhg_1.q6v_1).iem($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  } catch ($p) {
    if ($p instanceof ConnectionException()) {
      var e = $p;
      printStackTrace2(e);
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_1 = get_session();
      var tmp_1 = await_0(this_1, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var tmp_2 = tmp_1.bfw_1;
      var tmp_3 = (it) => it.s6v_1.equals($this.mhg_1.kf9_1);
      tmp_2.ceo(tmp_3, PayAppForm$PayAppItemForm$delete$lambda);
    } else {
      throw $p;
    }
  }
  cache.t3($this.mhg_1.kf9_1);
  return Unit_instance;
}
function workCompleted($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(false);
  view.zb8(get_dp(3));
  var tmp = get_centered(view);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.jba(view_0.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp_0 = KMutableProperty0();
  var tmp_1 = TextView$_get_content_$ref_4pzcwl(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    var tmp$ret$0 = MonetaryValue__toString_impl_xslc77($this$reactiveScope.baj($this.whg_1).a5s_1);
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  var tmp_2 = get_centered(view);
  // Inline function 'com.crowpay.views.theming.smallBody' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_1 = view.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.ebb(p_1, view_1);
  view_1.jba(view_1.ob6_1.ybe(SmallBodySemantic_getInstance()));
  var tmp_3 = KMutableProperty0();
  var tmp_4 = TextView$_get_content_$ref_4pzcwl_0(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb_0(view_1));
  reactiveScope(view_1, ($this$reactiveScope) => {
    // Inline function 'kotlin.takeUnless' call
    var this_0 = new (MonetaryValue())($this.mhg_1.v91());
    var tmp;
    var it = this_0.a5s_1;
    if (!(MonetaryValue__compareTo_impl_w7ul1r(it, Companion_instance.p91(0n)) <= 0)) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp_0 = tmp;
    var tmp0_safe_receiver = tmp_0 == null ? null : tmp_0.a5s_1;
    var tmp_1;
    var tmp_2 = tmp0_safe_receiver;
    if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
      tmp_1 = null;
    } else {
      var tmp_3 = tmp0_safe_receiver;
      // Inline function 'kotlin.let' call
      var it_0 = (tmp_3 == null ? null : new (MonetaryValue())(tmp_3)).a5s_1;
      tmp_1 = '(' + renderPercent(percentComplete($this$reactiveScope.baj($this.whg_1).a5s_1, it_0)) + ')';
    }
    var tmp1_elvis_lhs = tmp_1;
    var tmp$ret$11 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    this_1.set(tmp$ret$11);
    return Unit_instance;
  });
  view.fbb(p_1, view_1);
  view.jbb(tmp_2, view_1);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function drawInput($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = _this__u8e3s4.hbb(FieldSemantic_getInstance());
  var tmp_0 = _this__u8e3s4.ibb(tmp, validate(_this__u8e3s4, [$this.uhg_1, $this.phg_1], ($this$validate) => !($this$validate.baj($this.uhg_1) == null)));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(false);
  view.zb8(get_current(Companion_instance_0).equals(Platform_Web_getInstance()) ? get_rem(0) : get_dp(5));
  view.eba(get_current(Companion_instance_0).equals(Platform_Web_getInstance()) ? get_rem_0(0.2) : get_dp(5));
  var tmp_1 = get_centered(view);
  // Inline function 'com.crowpay.views.components.monetaryValueInput' call
  // Inline function 'kotlin.also' call
  var this_0 = new (MonetaryValueInput())(view);
  view.eba(get_current(Companion_instance_0).equals(Platform_Web_getInstance()) ? get_rem_0(0.2) : get_dp(5));
  if (get_viewIsNarrow(view)) {
    this_0.tcl('Max ' + MonetaryValue__toString_impl_xslc77($this.thg_1));
  }
  view.xah(this_0.gg9_1, zeroToNull($this.uhg_1));
  var tmp$ret$3 = this_0.jg9_1;
  view.jbb(tmp_1, tmp$ret$3);
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp_0, view);
}
function PayAppForm$PayAppItemForm$delete$lambda(it) {
  return null;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_4($this, it, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.lhh_1.af5_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = resolveProjectAttachments(tmp$ret$0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return it.r6y(VOID, VOID, VOID, VOID, VOID, VOID, tmp_0);
}
function *_generator_invoke__zhh2q8_5($this, $this$launch, $completion) {
  var tmp = $this.mhh_1.nhh(VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $this$coroutineScope, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ohh_1.xf4_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    launch($this$coroutineScope, VOID, VOID, PayAppForm$save$slambda$slambda_0(element));
  }
  return Unit_instance;
}
var PayAppForm$save$slambda$slambdaClass;
function PayAppForm$save$slambda$slambda() {
  if (PayAppForm$save$slambda$slambdaClass === VOID) {
    class $ {
      constructor($it) {
        this.mhh_1 = $it;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    PayAppForm$save$slambda$slambdaClass = $;
  }
  return PayAppForm$save$slambda$slambdaClass;
}
function PayAppForm$save$slambda$slambda_0($it) {
  var i = new (PayAppForm$save$slambda$slambda())($it);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_7($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  return LiveApi2$Api2PayApplicationLive$uploadFileForRequest$ref_0(tmp$ret$0.tfw().lfg_1);
}
var LiveApi2$Api2PayApplicationLive$uploadFileForRequest$refClass;
function LiveApi2$Api2PayApplicationLive$uploadFileForRequest$ref() {
  if (LiveApi2$Api2PayApplicationLive$uploadFileForRequest$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.phh_1 = p0;
      }
      sao($completion) {
        return this.phh_1.jfi($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LiveApi2$Api2PayApplicationLive$uploadFileForRequest$refClass = $;
  }
  return LiveApi2$Api2PayApplicationLive$uploadFileForRequest$refClass;
}
function LiveApi2$Api2PayApplicationLive$uploadFileForRequest$ref_0(p0) {
  var i = new (LiveApi2$Api2PayApplicationLive$uploadFileForRequest$ref())(p0);
  var l = ($completion) => i.sao($completion);
  l.callableName = 'uploadFileForRequest';
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_8($this, $this$Action, $completion) {
  var tmp = save($this.qhh_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_9($this, $this$Action, $completion) {
  var tmp = save($this.rhh_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.rhh_1.thh($this.shh_1);
  return Unit_instance;
}
var PayAppForm$actionBar$discardButton$slambda$slambdaClass;
function PayAppForm$actionBar$discardButton$slambda$slambda() {
  if (PayAppForm$actionBar$discardButton$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.uhh_1 = this$0;
        this.vhh_1 = $$this$button;
      }
      cgk(it, $completion) {
        if (it) {
          this.uhh_1.thh(this.vhh_1);
        }
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    PayAppForm$actionBar$discardButton$slambda$slambdaClass = $;
  }
  return PayAppForm$actionBar$discardButton$slambda$slambdaClass;
}
function PayAppForm$actionBar$discardButton$slambda$slambda_0(this$0, $$this$button) {
  var i = new (PayAppForm$actionBar$discardButton$slambda$slambda())(this$0, $$this$button);
  var l = (it, $completion) => i.cgk(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_10($this, it, $completion) {
  if (it) {
    var tmp = deleteAndExit($this.whh_1, $this.xhh_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
var PayAppForm$actionBar$deleteButton$slambda$slambdaClass;
function PayAppForm$actionBar$deleteButton$slambda$slambda() {
  if (PayAppForm$actionBar$deleteButton$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.whh_1 = this$0;
        this.xhh_1 = $$this$button;
      }
      cgk(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    PayAppForm$actionBar$deleteButton$slambda$slambdaClass = $;
  }
  return PayAppForm$actionBar$deleteButton$slambda$slambdaClass;
}
function PayAppForm$actionBar$deleteButton$slambda$slambda_0(this$0, $$this$button) {
  var i = new (PayAppForm$actionBar$deleteButton$slambda$slambda())(this$0, $$this$button);
  var l = (it, $completion) => i.cgk(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_11($this, $completion) {
  var tmp = save($this.yhh_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var session = tmp_0;
  var tmp_1 = session.tfw().lfg_1.ufn($this.yhh_1.ef4_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = session.afw_1.beo($completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = session.bfw_1.beo($completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  $this.yhh_1.thh($this.zhh_1);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_12($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.bhi_1.yf4_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp.a5s_1;
  var tmp_0 = 'Submit Draw : ' + MonetaryValue__toString_impl_xslc77(tmp$ret$0);
  confirmationDialog($this.ahi_1, tmp_0, '', 'Submit', VOID, VOID, VOID, VOID, VOID, VOID, PayAppForm$actionBar$submitButton$slambda$slambda_0($this.bhi_1, $this.ahi_1));
  return Unit_instance;
}
var PayAppForm$actionBar$submitButton$slambda$slambdaClass;
function PayAppForm$actionBar$submitButton$slambda$slambda() {
  if (PayAppForm$actionBar$submitButton$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.yhh_1 = this$0;
        this.zhh_1 = $$this$button;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    PayAppForm$actionBar$submitButton$slambda$slambdaClass = $;
  }
  return PayAppForm$actionBar$submitButton$slambda$slambdaClass;
}
function PayAppForm$actionBar$submitButton$slambda$slambda_0(this$0, $$this$button) {
  var i = new (PayAppForm$actionBar$submitButton$slambda$slambda())(this$0, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_save__qhzefp_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.af5_1.aak();
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (tmp_0) {
    var tmp_1 = modify($this.gf4_1, PayAppForm$save$slambda_0($this), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  var tmp_2 = pushChanges($this.gf4_1, session.afw_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = coroutineScope(PayAppForm$save$slambda_2($this), $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function save($this, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_save__qhzefp_0.bind(VOID, $this), $completion);
}
function *_generator_deleteAndExit__5riidm($this, _this__u8e3s4, $completion) {
  // Inline function 'kotlin.also' call
  get_mainPageNavigator(_this__u8e3s4).qd6();
  var tmp = delay(500n, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.afw_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.gf4_1;
  var tmp_2 = await_0(this_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp$ret$1 = tmp_2;
  var tmp_3 = tmp_1.kft(tmp$ret$1.i6y_1).iem($completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function deleteAndExit($this, _this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_deleteAndExit__5riidm.bind(VOID, $this, _this__u8e3s4), $completion);
}
function drawSummary($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.eba(get_dp(5));
  view.zb8(get_dp(5));
  var rowSpacing = get_rem(1);
  var tmp = get_centered(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
  var breakpoint = get_AppDimensions().gg2_1;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowCollapsingToColumn())(view.pc(), listOf(new (Dimension())(breakpoint)));
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.zb8(times(get_AppDimensions().zg1_1, 1.5));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
  var breakpoint_0 = get_AppDimensions().gg2_1;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowCollapsingToColumn())(view_1.pc(), listOf(new (Dimension())(breakpoint_0)));
  var tmp0_elvis_lhs_2 = view_1.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.ebb(p_2, view_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Space())(view_2.pc(), 0.1);
  var tmp0_elvis_lhs_3 = view_2.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.ebb(p_3, view_3);
  view_2.fbb(p_3, view_3);
  bodyBold(view_2, 'Project Value Breakdown');
  view_1.fbb(p_2, view_2);
  view_1.jbb(get_lightSection(view_1), drawSummary$_anonymous_$projectValueStatement_5ban4y(view_1, rowSpacing, $this));
  view_0.fbb(p_1, view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_4 = view_0.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
  view_0.ebb(p_4, view_4);
  view_4.xbm(true);
  bodyBold(view_4, 'Total Draws to Date');
  drawSummary$_anonymous_$totalDrawsToDate_i4i7rn(view_4, rowSpacing, $this);
  view_0.fbb(p_4, view_4);
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function descriptionInput($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  // Inline function 'com.crowpay.views.components.field2' call
  var label = 'Description';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  view_0.zb8(get_AppDimensions().ng2_1);
  bodyBold(view_0, label);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = view_0.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextArea())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  var this_0 = $this.gf4_1;
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(PayApplication()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$1);
  var tmp$ret$3 = get_description(it);
  var tmp$ret$4 = lensPath(this_0, tmp$ret$3);
  view_1.xah(view_1.qcl_1, tmp$ret$4);
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp, view_1);
  view_0.jbb(view_0.hbb(SubtextSemantic_getInstance()), errorText(view_0));
  view.fbb(p_0, view_0);
  // Inline function 'com.crowpay.views.components.field2' call
  var label_0 = 'Attachments';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_2 = view.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
  view.ebb(p_2, view_2);
  view_2.xbm(true);
  view_2.zb8(get_AppDimensions().ng2_1);
  bodyBold(view_2, label_0);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_1 = view_2.hbb(FieldSemantic_getInstance());
  var tmp$ret$15 = fileManager(view_2, $this.af5_1, 'No Attachments Uploaded', VOID, VOID, PayAppForm$descriptionInput$slambda_0());
  view_2.jbb(tmp_1, tmp$ret$15);
  view_2.jbb(view_2.hbb(SubtextSemantic_getInstance()), errorText(view_2));
  view.fbb(p_2, view_2);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function overdrawBanners($this, _this__u8e3s4) {
  var overdrawing = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$remember.baj(get_issues($this.uf4_1)).i1();
  });
  var tmp = shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => {
    var tmp;
    if ($this$shownWhen.baj(overdrawing)) {
      tmp = true;
    } else {
      // Inline function 'kotlin.let' call
      var it = $this$shownWhen.baj($this.hf4_1);
      tmp = MonetaryValue__compareTo_impl_w7ul1r(it.c7c_1, it.y7b_1) < 0;
    }
    return tmp;
  });
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
  dynamicTheme(view, ($this$dynamicTheme) => NotificationBarSemantic().lg0($this$dynamicTheme.baj(overdrawing) ? AppColors_getInstance().hfz_1 : AppColors_getInstance().ifz_1));
  var tmp_0 = KMutableProperty0();
  var tmp_1 = TextView$_get_content_$ref_4pzcwl_4(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_4(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var max = $this$reactiveScope.baj($this.tf4_1).a5s_1;
    var tmp$ret$3 = $this$reactiveScope.baj(overdrawing) ? 'You have exceeded the maximum draw of ' + MonetaryValue__toString_impl_xslc77(max) + '. Please contact the client to deposit remaining funds or lower draw amount.' : 'The client has not deposited all required funds into escrow. Because of this, you are limited to a maximum draw of ' + MonetaryValue__toString_impl_xslc77(max) + '.';
    this_0.set(tmp$ret$3);
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function table($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  var $this$col = view_0;
  trackWeights(($this$trackWeights) => {
    $this$trackWeights.kg6_1 = get_rem_0(0.5);
    // Inline function 'com.crowpay.views.theming.subTitle' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    var this_0 = $this$col;
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (TextView())(this_0.pc());
    var tmp0_elvis_lhs = this_0.cbb_1;
    var p = tmp0_elvis_lhs == null ? this_0 : tmp0_elvis_lhs;
    this_0.ebb(p, view);
    view.jba(view.ob6_1.ybe(SubtitleSemantic_getInstance()));
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl_5(view);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_5(view));
    reactiveScope(view, ($this$reactiveScope) => {
      var tmp$ret$0 = 'Draw ' + $this$reactiveScope.baj($this.gf4_1).k6y_1 + ': ' + format($this$reactiveScope.baj($this.gf4_1).l6y_1, Formats_getInstance().j8z_1);
      this_1.set(tmp$ret$0);
      return Unit_instance;
    });
    this_0.fbb(p, view);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    var this_2 = $this$col;
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(this_2.pc());
    var tmp0_elvis_lhs_0 = this_2.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? this_2 : tmp0_elvis_lhs_0;
    this_2.ebb(p_0, view_0);
    view_0.xbm(false);
    view_0.zb8($this$trackWeights.kg6_1);
    view_0.jbb(view_0.ibb($this$trackWeights.mg6(view_0, 1.5), get_atBottomStart(view_0)), bodyBold(view_0, 'Work Item'));
    view_0.jbb(view_0.ibb($this$trackWeights.mg6(view_0, 1.5), get_atBottomCenter(view_0)), table$_anonymous_$_anonymous_$_anonymous_$_anonymous_$columnLabel$0_y99dyg(view_0, 'Approved', 'Approved work including changes'));
    view_0.jbb(view_0.ibb($this$trackWeights.mg6(view_0, 1.0), get_atBottomCenter(view_0)), table$_anonymous_$_anonymous_$_anonymous_$_anonymous_$columnLabel$0_y99dyg(view_0, 'Processed', 'Draw items that have been paid and work items that have been signed off as done.'));
    view_0.jbb(view_0.ibb($this$trackWeights.mg6(view_0, 1.0), get_atBottomCenter(view_0)), table$_anonymous_$_anonymous_$_anonymous_$_anonymous_$columnLabel$0_y99dyg(view_0, 'Pending', 'Work items that are in Request Sign-Off status or draw items that are open.'));
    view_0.jbb(view_0.ibb($this$trackWeights.mg6(view_0, 1.0), get_atBottomCenter(view_0)), table$_anonymous_$_anonymous_$_anonymous_$_anonymous_$columnLabel$0_y99dyg(view_0, 'Draw', 'Value of work being submitted for this draw.'));
    var tmp_1 = view_0.ibb($this$trackWeights.mg6(view_0, 1.5), get_atBottomCenter(view_0));
    view_0.jbb(tmp_1, table$_anonymous_$_anonymous_$_anonymous_$_anonymous_$columnLabel_3d0u44(view_0, 'All work values from processed, pending, and this draw', PayAppForm$table$lambda$lambda));
    view_0.jbb(view_0.ibb($this$trackWeights.mg6(view_0, 1.0), get_atBottomCenter(view_0)), table$_anonymous_$_anonymous_$_anonymous_$_anonymous_$columnLabel$0_y99dyg(view_0, 'Remaining', 'Remaining work value on that work item.'));
    var tmp_2 = view_0.ibb($this$trackWeights.mg6(view_0, 1.0), get_atBottomCenter(view_0));
    view_0.jbb(tmp_2, table$_anonymous_$_anonymous_$_anonymous_$_anonymous_$columnLabel_3d0u44(view_0, 'The portion of retention total allocated to this item based on Work To-Date.', ($this$columnLabel) => {
      var tmp = get_atBottomStart($this$columnLabel);
      // Inline function 'com.crowpay.views.theming.bodyBold' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (TextView())($this$columnLabel.pc());
      var tmp0_elvis_lhs = $this$columnLabel.cbb_1;
      var p = tmp0_elvis_lhs == null ? $this$columnLabel : tmp0_elvis_lhs;
      $this$columnLabel.ebb(p, view);
      view.jba(view.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
      view.yco(true);
      var tmp_0 = KMutableProperty0();
      var tmp_1 = TextView$_get_content_$ref_4pzcwl_6(view);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_6(view));
      reactiveScope(view, ($this$reactiveScope) => {
        var tmp$ret$7 = 'Retention Portion (' + renderPercent($this$reactiveScope.baj($this.hf4_1).u97()) + ')';
        this_0.set(tmp$ret$7);
        return Unit_instance;
      });
      $this$columnLabel.fbb(p, view);
      return $this$columnLabel.jbb(tmp, view);
    }));
    this_2.fbb(p_0, view_0);
    greySeparator($this$col);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_3 = $this$col;
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(this_3.pc());
    var tmp0_elvis_lhs_1 = this_3.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? this_3 : tmp0_elvis_lhs_1;
    this_3.ebb(p_1, view_1);
    view_1.xbm(true);
    var groupedForms = remember(VOID, true, VOID, ($this$remember) => {
      // Inline function 'kotlin.collections.associateBy' call
      var this_0 = $this$remember.baj($this.of4_1);
      var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination = LinkedHashMap().fc(capacity);
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var tmp$ret$18 = element.k7z_1;
        destination.s3(tmp$ret$18, element);
      }
      var allScopes = destination;
      // Inline function 'kotlin.collections.groupBy' call
      var tmp0 = $this$remember.baj($this.xf4_1);
      // Inline function 'kotlin.collections.groupByTo' call
      var destination_0 = LinkedHashMap().f6();
      var _iterator__ex2g4s_0 = tmp0.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var element_0 = _iterator__ex2g4s_0.o1();
        var key = element_0.mhg_1.nfy();
        // Inline function 'kotlin.collections.getOrPut' call
        var value = destination_0.p3(key);
        var tmp;
        if (value == null) {
          var answer = ArrayList().w();
          destination_0.s3(key, answer);
          tmp = answer;
        } else {
          tmp = value;
        }
        var list = tmp;
        list.v(element_0);
      }
      var grouped = destination_0;
      // Inline function 'kotlin.collections.mapKeys' call
      // Inline function 'kotlin.collections.mapKeysTo' call
      var destination_1 = LinkedHashMap().fc(mapCapacity(grouped.p1()));
      // Inline function 'kotlin.collections.associateByTo' call
      var _iterator__ex2g4s_1 = grouped.d2().m1();
      while (_iterator__ex2g4s_1.n1()) {
        var element_1 = _iterator__ex2g4s_1.o1();
        // Inline function 'kotlin.collections.component1' call
        var scopeId = element_1.e2();
        // Inline function 'kotlin.collections.get' call
        var tmp_0 = (isInterface(allScopes, KtMap()) ? allScopes : THROW_CCE()).p3(scopeId);
        var tmp$ret$29 = element_1.f2();
        destination_1.s3(tmp_0, tmp$ret$29);
      }
      // Inline function 'kotlin.collections.sortedBy' call
      var this_1 = toList(destination_1);
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_1 = PayAppForm$table$lambda$lambda$lambda;
      var tmp$ret$33 = new (sam$kotlin_Comparator$0_3())(tmp_1);
      return sortedWith(this_1, tmp$ret$33);
    });
    forEach(view_1, groupedForms, ($this$forEach, _destruct__k2r9zo) => {
      var scope = _destruct__k2r9zo.cf();
      var forms = _destruct__k2r9zo.df();
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (RowOrCol())($this$forEach.pc());
      var tmp0_elvis_lhs = $this$forEach.cbb_1;
      var p = tmp0_elvis_lhs == null ? $this$forEach : tmp0_elvis_lhs;
      $this$forEach.ebb(p, view);
      view.xbm(true);
      if (!(scope == null)) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.xbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Space())(view_0.pc(), 0.25);
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_0.fbb(p_1, view_1);
        var tmp = view_0.ibb(get_compact(view_0), get_lightSection(view_0));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_2 = view_0.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
        view_0.ebb(p_2, view_2);
        view_2.xbm(false);
        if (scope.p7z_1) {
          view_2.jbb(get_centered(view_2), scopeSetIcon(view_2, get_rem(1)));
        }
        body(view_2, scope.m7z_1);
        view_0.fbb(p_2, view_2);
        view_0.jbb(tmp, view_2);
        view.fbb(p_0, view_0);
      }
      var _iterator__ex2g4s = forms.m1();
      while (_iterator__ex2g4s.n1()) {
        var form = _iterator__ex2g4s.o1();
        form.chi(view, $this$trackWeights);
        greySeparator(view);
      }
      $this$forEach.fbb(p, view);
      return Unit_instance;
    });
    this_3.fbb(p_1, view_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    var this_4 = $this$col;
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RowOrCol())(this_4.pc());
    var tmp0_elvis_lhs_2 = this_4.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? this_4 : tmp0_elvis_lhs_2;
    this_4.ebb(p_2, view_2);
    view_2.xbm(false);
    view_2.zb8($this$trackWeights.kg6_1);
    view_2.jbb($this$trackWeights.ng6(view_2), bodyBold(view_2, 'Totals'));
    var tmp_3 = $this$trackWeights.ng6(view_2);
    view_2.jbb(tmp_3, table$_anonymous_$_anonymous_$_anonymous_$_anonymous_$total_a0lejy(view_2, ($this$total) => {
      // Inline function 'com.crowpay.extensions.sumMoney' call
      var this_0 = $this$total.baj($this.mf4_1);
      var sum = Companion_instance.p91(0n);
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var tmp = sum;
        var tmp$ret$54 = element.v91();
        sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$54);
      }
      var tmp$ret$55 = sum;
      return new (MonetaryValue())(tmp$ret$55);
    }));
    var tmp_4 = $this$trackWeights.ng6(view_2);
    view_2.jbb(tmp_4, table$_anonymous_$_anonymous_$_anonymous_$_anonymous_$total_a0lejy(view_2, ($this$total) => {
      // Inline function 'com.crowpay.extensions.sumMoney' call
      var this_0 = $this$total.baj($this.xf4_1);
      var sum = Companion_instance.p91(0n);
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var tmp = sum;
        var tmp$ret$56 = element.rhg_1;
        sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$56);
      }
      var tmp$ret$57 = sum;
      return new (MonetaryValue())(tmp$ret$57);
    }));
    var tmp_5 = $this$trackWeights.ng6(view_2);
    view_2.jbb(tmp_5, table$_anonymous_$_anonymous_$_anonymous_$_anonymous_$total_a0lejy(view_2, ($this$total) => {
      // Inline function 'com.crowpay.extensions.sumMoney' call
      var this_0 = $this$total.baj($this.xf4_1);
      var sum = Companion_instance.p91(0n);
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var tmp = sum;
        var tmp$ret$58 = element.qhg_1;
        sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$58);
      }
      var tmp$ret$59 = sum;
      return new (MonetaryValue())(tmp$ret$59);
    }));
    var tmp_6 = $this$trackWeights.ng6(view_2);
    view_2.jbb(tmp_6, table$_anonymous_$_anonymous_$_anonymous_$_anonymous_$total_a0lejy(view_2, ($this$total) => $this$total.baj($this.yf4_1)));
    var tmp_7 = $this$trackWeights.ng6(view_2);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Frame())(view_2.pc());
    var tmp0_elvis_lhs_3 = view_2.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
    view_2.ebb(p_3, view_3);
    var tmp_8 = get_centered(view_3);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (RowOrCol())(view_3.pc());
    var tmp0_elvis_lhs_4 = view_3.cbb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
    view_3.ebb(p_4, view_4);
    view_4.xbm(false);
    view_4.zb8(get_dp(5));
    // Inline function 'com.crowpay.views.theming.bodyBold' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (TextView())(view_4.pc());
    var tmp0_elvis_lhs_5 = view_4.cbb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
    view_4.ebb(p_5, view_5);
    view_5.jba(view_5.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
    var tmp_9 = KMutableProperty0();
    var tmp_10 = TextView$_get_content_$ref_4pzcwl_7(view_5);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_5 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, TextView$_set_content_$ref_pketfb_7(view_5));
    reactiveScope(view_5, ($this$reactiveScope) => {
      var tmp$ret$60 = MonetaryValue__toString_impl_xslc77($this$reactiveScope.baj($this.zf4_1).a5s_1);
      this_5.set(tmp$ret$60);
      return Unit_instance;
    });
    view_4.fbb(p_5, view_5);
    // Inline function 'com.crowpay.views.theming.smallBody' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_6 = new (TextView())(view_4.pc());
    var tmp0_elvis_lhs_6 = view_4.cbb_1;
    var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
    view_4.ebb(p_6, view_6);
    view_6.jba(view_6.ob6_1.ybe(SmallBodySemantic_getInstance()));
    view_6.bbs(Align_Center_getInstance());
    var tmp_11 = KMutableProperty0();
    var tmp_12 = TextView$_get_content_$ref_4pzcwl_8(view_6);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_6 = getPropertyCallableRef('content', 0, tmp_11, tmp_12, TextView$_set_content_$ref_pketfb_8(view_6));
    reactiveScope(view_6, ($this$reactiveScope) => {
      var price = $this$reactiveScope.baj($this.hf4_1).y7b_1;
      var tmp$ret$67 = '(' + renderPercent(percentComplete($this$reactiveScope.baj($this.zf4_1).a5s_1, price)) + ')';
      this_6.set(tmp$ret$67);
      return Unit_instance;
    });
    view_4.fbb(p_6, view_6);
    view_3.fbb(p_4, view_4);
    view_3.jbb(tmp_8, view_4);
    view_2.fbb(p_3, view_3);
    view_2.jbb(tmp_7, view_3);
    var tmp_13 = $this$trackWeights.ng6(view_2);
    view_2.jbb(tmp_13, table$_anonymous_$_anonymous_$_anonymous_$_anonymous_$total_a0lejy(view_2, ($this$total) => new (MonetaryValue())(MonetaryValue__minus_impl_jw9qyp($this$total.baj($this.hf4_1).y7b_1, $this$total.baj($this.zf4_1).a5s_1))));
    var tmp_14 = $this$trackWeights.ng6(view_2);
    view_2.jbb(tmp_14, table$_anonymous_$_anonymous_$_anonymous_$_anonymous_$total_a0lejy(view_2, ($this$total) => new (MonetaryValue())(MonetaryValue__times_impl_hlr6p7($this$total.baj($this.zf4_1).a5s_1, $this$total.baj($this.hf4_1).u97()))));
    this_4.fbb(p_2, view_2);
    return Unit_instance;
  });
  view.fbb(p_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Space())(view.pc(), 0.25);
  var tmp0_elvis_lhs_1 = view.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.ebb(p_1, view_1);
  view.fbb(p_1, view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_2 = view.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
  view.ebb(p_2, view_2);
  view_2.xbm(true);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  var content = 'This Draw';
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextView())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.ebb(p_3, view_3);
  view_3.jba(view_3.ob6_1.ybe(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = view_3.tb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = content;
  }
  tmp.fbu(tmp_0);
  view_2.fbb(p_3, view_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_4 = view_2.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
  view_2.ebb(p_4, view_4);
  view_4.xbm(false);
  var tmp_1 = get_lightSection(view_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (Frame())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.ebb(p_5, view_5);
  var tmp_2 = get_centered(view_5);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view_5.pc());
  var tmp0_elvis_lhs_6 = view_5.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
  view_5.ebb(p_6, view_6);
  view_6.xbm(true);
  view_6.zb8(get_AppDimensions().jg2_1);
  table$_anonymous_$_anonymous_$money_3n1w1o(view_6, ($this$money) => $this$money.baj($this.yf4_1));
  view_6.jbb(get_centered(view_6), body(view_6, 'Work Value'));
  view_5.fbb(p_6, view_6);
  view_5.jbb(tmp_2, view_6);
  view_4.fbb(p_5, view_5);
  view_4.jbb(tmp_1, view_5);
  view_4.jbb(get_centered(view_4), bodyBold(view_4, '-'));
  var tmp_3 = get_lightSection(view_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (Frame())(view_4.pc());
  var tmp0_elvis_lhs_7 = view_4.cbb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_4 : tmp0_elvis_lhs_7;
  view_4.ebb(p_7, view_7);
  var tmp_4 = get_centered(view_7);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (RowOrCol())(view_7.pc());
  var tmp0_elvis_lhs_8 = view_7.cbb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
  view_7.ebb(p_8, view_8);
  view_8.xbm(true);
  view_8.zb8(get_AppDimensions().jg2_1);
  table$_anonymous_$_anonymous_$money_3n1w1o(view_8, ($this$money) => new (MonetaryValue())(MonetaryValue__times_impl_hlr6p7($this$money.baj($this.yf4_1).a5s_1, $this$money.baj($this.hf4_1).u97())));
  view_8.jbb(get_centered(view_8), body(view_8, 'Retention'));
  view_7.fbb(p_8, view_8);
  view_7.jbb(tmp_4, view_8);
  view_4.fbb(p_7, view_7);
  view_4.jbb(tmp_3, view_7);
  view_4.jbb(get_centered(view_4), bodyBold(view_4, '='));
  var tmp_5 = get_lightSection(view_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (Frame())(view_4.pc());
  var tmp0_elvis_lhs_9 = view_4.cbb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_4 : tmp0_elvis_lhs_9;
  view_4.ebb(p_9, view_9);
  var tmp_6 = get_centered(view_9);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (RowOrCol())(view_9.pc());
  var tmp0_elvis_lhs_10 = view_9.cbb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_9 : tmp0_elvis_lhs_10;
  view_9.ebb(p_10, view_10);
  view_10.xbm(true);
  view_10.zb8(get_AppDimensions().jg2_1);
  var tmp_7 = colored(view_10, AppColors_getInstance().dfz_1.xg9_1);
  view_10.jbb(tmp_7, table$_anonymous_$_anonymous_$money_3n1w1o(view_10, ($this$money) => new (MonetaryValue())(MonetaryValue__times_impl_hlr6p7($this$money.baj($this.yf4_1).a5s_1, 1 - $this$money.baj($this.hf4_1).u97()))));
  view_10.jbb(get_centered(view_10), body(view_10, 'Payment'));
  view_9.fbb(p_10, view_10);
  view_9.jbb(tmp_6, view_10);
  view_4.fbb(p_9, view_9);
  view_4.jbb(tmp_5, view_9);
  view_2.fbb(p_4, view_4);
  view.fbb(p_2, view_2);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function renderWide($this, _this__u8e3s4) {
  var tmp = get_scrolling(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  var tmp_0 = view.ibb(align(view, Align_Start_getInstance(), Align_Start_getInstance()), sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, plus(get_AppDimensions().eg2_1, get_rem(10))));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  view_0.zb8(get_AppDimensions().zg1_1);
  title(view_0, ($this$title) => {
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl_9($this$title);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_9($this$title));
    reactiveScope($this$title, ($this$reactiveScope) => {
      var tmp$ret$0 = $this$reactiveScope.baj($this.hf4_1).d7b_1 + ' Draw ' + $this$reactiveScope.baj($this.gf4_1).k6y_1;
      this_0.set(tmp$ret$0);
      return Unit_instance;
    });
    return Unit_instance;
  });
  $this.th6(view_0);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  var content = 'Draw Summary';
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.jba(view_1.ob6_1.ybe(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_1 = view_1.tb5_1;
  var tmp_2;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content) === 0) {
    tmp_2 = '\xA0';
  } else {
    tmp_2 = content;
  }
  tmp_1.fbu(tmp_2);
  view_0.fbb(p_1, view_1);
  view_0.jbb(get_centered(view_0), drawSummary($this, view_0));
  descriptionInput($this, view_0);
  view_0.jbb(get_centered(view_0), overdrawBanners($this, view_0));
  $this.th6(view_0);
  table($this, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Space())(view_0.pc(), 10.0);
  var tmp0_elvis_lhs_2 = view_0.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.ebb(p_2, view_2);
  view_0.fbb(p_2, view_2);
  view.fbb(p_0, view_0);
  view.jbb(tmp_0, view_0);
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
var SectionClass;
function Section() {
  if (SectionClass === VOID) {
    class $ extends Enum() {
      static jhg(name, ordinal, displayName) {
        var $this = this.c4(name, ordinal);
        $this.ihg_1 = displayName;
        return $this;
      }
      g90() {
        return this.ihg_1;
      }
    }
    protoOf($).f90 = get_shortDisplayName;
    initMetadataForClass($, 'Section', VOID, VOID, [HasDisplayName(), Enum()]);
    SectionClass = $;
  }
  return SectionClass;
}
function renderNarrow($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  var selectedSection = Signal().fak(Section_Summary_getInstance());
  var tmp = view.ibb(get_expanding(view), get_scrolling(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  title(view_0, ($this$title) => {
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl_10($this$title);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_10($this$title));
    reactiveScope($this$title, ($this$reactiveScope) => {
      var tmp$ret$0 = $this$reactiveScope.baj($this.hf4_1).d7b_1 + ' Draw ' + $this$reactiveScope.baj($this.gf4_1).k6y_1;
      this_0.set(tmp$ret$0);
      return Unit_instance;
    });
    return Unit_instance;
  });
  overdrawBanners($this, view_0);
  var tmp_0 = view_0.hbb(InnerTabBar_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(false);
  var _iterator__ex2g4s = get_entries().m1();
  while (_iterator__ex2g4s.n1()) {
    var section = _iterator__ex2g4s.o1();
    var tmp_1 = get_expanding(view_1);
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var tmp$ret$2 = view_1.hbb(ButtonSemantic_getInstance());
    var tmp_2 = view_1.ibb(tmp_1, tmp$ret$2);
    // Inline function 'com.lightningkite.kiteui.views.direct.radioToggleButton' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RadioToggleButton())(view_1.pc());
    var tmp0_elvis_lhs_2 = view_1.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
    view_1.ebb(p_2, view_2);
    view_2.jbb(get_centered(view_2), body(view_2, section.ihg_1));
    view_2.xah(view_2.zc8_1, equalTo(selectedSection, section));
    view_1.fbb(p_2, view_2);
    view_1.jbb(tmp_2, view_2);
  }
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_0, view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Frame())(view_0.pc());
  var tmp0_elvis_lhs_3 = view_0.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
  view_0.ebb(p_3, view_3);
  var $this$frame = view_3;
  reactive($this$frame, ($this$reactive) => {
    $this$frame.zb9();
    var tmp;
    switch ($this$reactive.baj(selectedSection).b4_1) {
      case 0:
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call

        var this_0 = $this$frame;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call

        var view = new (RowOrCol())(this_0.pc());
        var tmp0_elvis_lhs = this_0.cbb_1;
        var p = tmp0_elvis_lhs == null ? this_0 : tmp0_elvis_lhs;
        this_0.ebb(p, view);
        view.xbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call

        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call

        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.eba(get_dp(5));
        descriptionInput($this, view_0);
        view.fbb(p_0, view_0);
        drawSummary($this, view);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call

        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call

        var view_1 = new (Space())(view.pc(), 2.0);
        var tmp0_elvis_lhs_1 = view.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.ebb(p_1, view_1);
        view.fbb(p_1, view_1);
        this_0.fbb(p, view);
        tmp = view;
        break;
      case 1:
        tmp = drawCards($this, $this$frame);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  });
  view_0.fbb(p_3, view_3);
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  $this.th6(view);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function drawCards($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  var tmp = view.ibb(get_atEnd(view), get_tertiaryButton(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Button())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  specCenteredText(view_0, '+ Draws');
  onClick(view_0, 'Add Draws', VOID, PayAppForm$drawCards$slambda_0($this));
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_1 = view.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.ebb(p_1, view_1);
  view_1.xbm(true);
  view_1.zb8(get_AppDimensions().zg1_1);
  var groupedForms = remember(VOID, true, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = $this$remember.baj($this.of4_1);
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap().fc(capacity);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp$ret$3 = element.k7z_1;
      destination.s3(tmp$ret$3, element);
    }
    var allScopes = destination;
    // Inline function 'kotlin.collections.groupBy' call
    var tmp0 = $this$remember.baj($this.vf4_1);
    // Inline function 'kotlin.collections.groupByTo' call
    var destination_0 = LinkedHashMap().f6();
    var _iterator__ex2g4s_0 = tmp0.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var element_0 = _iterator__ex2g4s_0.o1();
      var key = element_0.mhg_1.nfy();
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination_0.p3(key);
      var tmp;
      if (value == null) {
        var answer = ArrayList().w();
        destination_0.s3(key, answer);
        tmp = answer;
      } else {
        tmp = value;
      }
      var list = tmp;
      list.v(element_0);
    }
    // Inline function 'kotlin.collections.mapKeys' call
    // Inline function 'kotlin.collections.mapKeysTo' call
    var destination_1 = LinkedHashMap().fc(mapCapacity(destination_0.p1()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s_1 = destination_0.d2().m1();
    while (_iterator__ex2g4s_1.n1()) {
      var element_1 = _iterator__ex2g4s_1.o1();
      // Inline function 'kotlin.collections.component1' call
      var scopeId = element_1.e2();
      // Inline function 'kotlin.collections.get' call
      var tmp_0 = (isInterface(allScopes, KtMap()) ? allScopes : THROW_CCE()).p3(scopeId);
      var tmp$ret$14 = element_1.f2();
      destination_1.s3(tmp_0, tmp$ret$14);
    }
    // Inline function 'kotlin.collections.sortedBy' call
    var this_1 = toList(destination_1);
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_1 = PayAppForm$drawCards$lambda$lambda;
    var tmp$ret$18 = new (sam$kotlin_Comparator$0_4())(tmp_1);
    return sortedWith(this_1, tmp$ret$18);
  });
  forEach(view_1, groupedForms, PayAppForm$drawCards$lambda);
  view.fbb(p_1, view_1);
  _this__u8e3s4.fbb(p, view);
  return view;
}
var SelectItemsDialogClass;
function SelectItemsDialog() {
  if (SelectItemsDialogClass === VOID) {
    class $ {
      constructor($outer) {
        this.hhh_1 = $outer;
        var tmp = this;
        tmp.ehh_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$remember.baj(this.hhh_1.vf4_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            var tmp$ret$0 = item.mhg_1.kf9_1;
            destination.v(tmp$ret$0);
          }
          return toSet(destination);
        });
        var tmp_0 = this;
        tmp_0.fhh_1 = MutableRemember().rak(VOID, VOID, VOID, VOID, ($this$MutableRemember) => $this$MutableRemember.baj(this.ehh_1));
        var tmp_1 = this;
        tmp_1.ghh_1 = remember(VOID, true, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.associateBy' call
          var this_0 = $this$remember.baj(this.hhh_1.of4_1);
          var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
          // Inline function 'kotlin.collections.associateByTo' call
          var destination = LinkedHashMap().fc(capacity);
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp$ret$3 = element.k7z_1;
            destination.s3(tmp$ret$3, element);
          }
          var allScopes = destination;
          // Inline function 'kotlin.collections.groupBy' call
          var tmp0 = $this$remember.baj(this.hhh_1.xf4_1);
          // Inline function 'kotlin.collections.groupByTo' call
          var destination_0 = LinkedHashMap().f6();
          var _iterator__ex2g4s_0 = tmp0.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            var key = element_0.mhg_1.nfy();
            // Inline function 'kotlin.collections.getOrPut' call
            var value = destination_0.p3(key);
            var tmp;
            if (value == null) {
              var answer = ArrayList().w();
              destination_0.s3(key, answer);
              tmp = answer;
            } else {
              tmp = value;
            }
            var list = tmp;
            list.v(element_0);
          }
          var grouped = destination_0;
          // Inline function 'kotlin.collections.mapKeys' call
          // Inline function 'kotlin.collections.mapKeysTo' call
          var destination_1 = LinkedHashMap().fc(mapCapacity(grouped.p1()));
          // Inline function 'kotlin.collections.associateByTo' call
          var _iterator__ex2g4s_1 = grouped.d2().m1();
          while (_iterator__ex2g4s_1.n1()) {
            var element_1 = _iterator__ex2g4s_1.o1();
            // Inline function 'kotlin.collections.component1' call
            var scopeId = element_1.e2();
            // Inline function 'kotlin.collections.get' call
            var tmp_0 = (isInterface(allScopes, KtMap()) ? allScopes : THROW_CCE()).p3(scopeId);
            var tmp$ret$14 = element_1.f2();
            destination_1.s3(tmp_0, tmp$ret$14);
          }
          // Inline function 'kotlin.collections.sortedBy' call
          var this_1 = toList(destination_1);
          // Inline function 'kotlin.comparisons.compareBy' call
          var tmp_1 = PayAppForm$SelectItemsDialog$groupedForms$lambda$lambda;
          var tmp$ret$18 = new (sam$kotlin_Comparator$0())(tmp_1);
          return sortedWith(this_1, tmp$ret$18);
        });
      }
      ud6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.tbo(PayAppForm$SelectItemsDialog$render$slambda_0());
        view.eba(get_AppDimensions().wg1_1);
        var tmp = view.ibb(align(view, Align_Stretch_getInstance(), Align_Center_getInstance()), view.hbb(DialogSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.eba(get_AppDimensions().wg1_1);
        var tmp_0 = view_0.hbb(RemoveOutline_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(true);
        var $this$col = view_1;
        $this$col.zb8(get_AppDimensions().zg1_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())($this$col.pc());
        var tmp0_elvis_lhs_2 = $this$col.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? $this$col : tmp0_elvis_lhs_2;
        $this$col.ebb(p_2, view_2);
        view_2.xbm(true);
        title_0(view_2, 'Add Draws');
        body(view_2, 'Select which items you want to add draws for.');
        $this$col.fbb(p_2, view_2);
        trackWeights(($this$trackWeights) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          var this_0 = $this$col;
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())(this_0.pc());
          var tmp0_elvis_lhs = this_0.cbb_1;
          var p = tmp0_elvis_lhs == null ? this_0 : tmp0_elvis_lhs;
          this_0.ebb(p, view);
          view.xbm(true);
          view.zb8(get_AppDimensions().ng2_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_0 = view.cbb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.ebb(p_0, view_0);
          view_0.xbm(false);
          view_0.zb8(get_AppDimensions().ig2_1);
          var tmp = $this$trackWeights.mg6(view_0, 0.4);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (Space())(view_0.pc());
          var tmp0_elvis_lhs_1 = view_0.cbb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
          view_0.ebb(p_1, view_1);
          view_0.fbb(p_1, view_1);
          view_0.jbb(tmp, view_1);
          view_0.jbb($this$trackWeights.mg6(view_0, 3.0), smallBody(view_0, 'Work Item'));
          var tmp_0 = $this$trackWeights.mg6(view_0, 1.1);
          // Inline function 'com.crowpay.views.theming.smallBody' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (TextView())(view_0.pc());
          var tmp0_elvis_lhs_2 = view_0.cbb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
          view_0.ebb(p_2, view_2);
          view_2.jba(view_2.ob6_1.ybe(SmallBodySemantic_getInstance()));
          view_2.bbs(Align_Center_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var value = 'Remaining';
          var tmp_1 = view_2.tb5_1;
          var tmp_2;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(value) === 0) {
            tmp_2 = '\xA0';
          } else {
            tmp_2 = value;
          }
          tmp_1.fbu(tmp_2);
          view_0.fbb(p_2, view_2);
          view_0.jbb(tmp_0, view_2);
          view.fbb(p_0, view_0);
          greySeparator(view);
          var tmp_3 = view.ibb(sizeConstraints(view, VOID, VOID, get_rem(20), get_rem(35)), get_scrolling(view));
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_3 = view.cbb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
          view.ebb(p_3, view_3);
          view_3.xbm(true);
          view_3.zb8(get_rem(1));
          var tmp_4 = view_3.hbb(ListSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (RowOrCol())(view_3.pc());
          var tmp0_elvis_lhs_4 = view_3.cbb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
          view_3.ebb(p_4, view_4);
          view_4.xbm(true);
          forEach(view_4, this.ghh_1, ($this$forEach, _destruct__k2r9zo) => {
            var scope = _destruct__k2r9zo.cf();
            var items = _destruct__k2r9zo.df();
            if (!(scope == null)) {
              var tmp = $this$forEach.ibb($this$forEach.hbb(LightSection_getInstance()), get_compact($this$forEach));
              // Inline function 'com.lightningkite.kiteui.views.direct.row' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view = new (RowOrCol())($this$forEach.pc());
              var tmp0_elvis_lhs = $this$forEach.cbb_1;
              var p = tmp0_elvis_lhs == null ? $this$forEach : tmp0_elvis_lhs;
              $this$forEach.ebb(p, view);
              view.xbm(false);
              if (scope.p7z_1) {
                view.jbb(get_centered(view), scopeSetIcon(view, get_rem(1)));
              }
              view.jbb(get_centered(view), body(view, scope.m7z_1));
              $this$forEach.fbb(p, view);
              $this$forEach.jbb(tmp, view);
            }
            var _iterator__ex2g4s = items.m1();
            while (_iterator__ex2g4s.n1()) {
              var option = _iterator__ex2g4s.o1();
              var selected = contains(this.fhh_1, option.mhg_1.kf9_1);
              var tmp_0 = $this$forEach.hbb(RemoveToggleSemantic_getInstance());
              // Inline function 'com.lightningkite.kiteui.views.direct.toggleButton' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_0 = new (ToggleButton())($this$forEach.pc());
              var tmp0_elvis_lhs_0 = $this$forEach.cbb_1;
              var p_0 = tmp0_elvis_lhs_0 == null ? $this$forEach : tmp0_elvis_lhs_0;
              $this$forEach.ebb(p_0, view_0);
              // Inline function 'com.lightningkite.kiteui.views.direct.ToggleButton.enabled' call
              var value = option.vhg_1;
              var tmp0 = view_0.mcq_1.zb3_1;
              // Inline function 'com.lightningkite.kiteui.views.disabled' call
              var value_0 = !value;
              tmp0.ib7_1.disabled = value_0;
              view_0.eba(get_dp(4));
              var tmp_1 = get_compact(view_0);
              // Inline function 'com.lightningkite.kiteui.views.direct.row' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_1 = new (RowOrCol())(view_0.pc());
              var tmp0_elvis_lhs_1 = view_0.cbb_1;
              var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
              view_0.ebb(p_1, view_1);
              view_1.xbm(false);
              view_1.zb8(get_AppDimensions().ig2_1);
              var tmp_2 = view_1.ibb($this$trackWeights.ng6(view_1), get_centered(view_1));
              // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_2 = new (Checkbox())(view_1.pc());
              var tmp0_elvis_lhs_2 = view_1.cbb_1;
              var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
              view_1.ebb(p_2, view_2);
              // Inline function 'com.lightningkite.kiteui.views.direct.Checkbox.enabled' call
              var value_1 = option.vhg_1;
              var tmp0_0 = view_2.tb5_1.zb3_1;
              // Inline function 'com.lightningkite.kiteui.views.disabled' call
              var value_2 = !value_1;
              tmp0_0.ib7_1.disabled = value_2;
              view_2.xah(view_2.cbk_1, selected);
              view_1.fbb(p_2, view_2);
              view_1.jbb(tmp_2, view_2);
              var tmp_3 = view_1.ibb($this$trackWeights.ng6(view_1), get_centered(view_1));
              // Inline function 'com.crowpay.views.theming.body' call
              // Inline function 'com.lightningkite.kiteui.views.direct.text' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view_3 = new (TextView())(view_1.pc());
              var tmp0_elvis_lhs_3 = view_1.cbb_1;
              var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
              view_1.ebb(p_3, view_3);
              view_3.jba(view_3.ob6_1.ybe(BodySemantic_getInstance()));
              // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
              var value_3 = option.mhg_1.lf9_1;
              var tmp_4 = view_3.tb5_1;
              var tmp_5;
              // Inline function 'kotlin.text.isEmpty' call
              if (charSequenceLength(value_3) === 0) {
                tmp_5 = '\xA0';
              } else {
                tmp_5 = value_3;
              }
              tmp_4.fbu(tmp_5);
              view_3.yco(false);
              view_3.xco(true);
              view_1.fbb(p_3, view_3);
              view_1.jbb(tmp_3, view_3);
              var tmp_6 = view_1.ibb($this$trackWeights.ng6(view_1), get_centered(view_1));
              var tmp0_elvis_lhs_4 = option.dhi(view_1);
              var tmp_7;
              if (tmp0_elvis_lhs_4 == null) {
                // Inline function 'com.crowpay.views.theming.body' call
                // Inline function 'com.lightningkite.kiteui.views.direct.text' call
                // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
                var view_4 = new (TextView())(view_1.pc());
                var tmp0_elvis_lhs_5 = view_1.cbb_1;
                var p_4 = tmp0_elvis_lhs_5 == null ? view_1 : tmp0_elvis_lhs_5;
                view_1.ebb(p_4, view_4);
                view_4.jba(view_4.ob6_1.ybe(BodySemantic_getInstance()));
                // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
                var value_4 = MonetaryValue__toString_impl_xslc77(option.mhg_1.hf9_1.o91());
                var tmp_8 = view_4.tb5_1;
                var tmp_9;
                // Inline function 'kotlin.text.isEmpty' call
                if (charSequenceLength(value_4) === 0) {
                  tmp_9 = '\xA0';
                } else {
                  tmp_9 = value_4;
                }
                tmp_8.fbu(tmp_9);
                view_4.bbs(Align_Center_getInstance());
                view_1.fbb(p_4, view_4);
                tmp_7 = view_4;
              } else {
                tmp_7 = tmp0_elvis_lhs_4;
              }
              view_1.jbb(tmp_6, tmp_7);
              view_0.fbb(p_1, view_1);
              view_0.jbb(tmp_1, view_1);
              view_0.xah(view_0.ncq_1, selected);
              $this$forEach.fbb(p_0, view_0);
              $this$forEach.jbb(tmp_0, view_0);
            }
            return Unit_instance;
          });
          view_3.fbb(p_4, view_4);
          view_3.jbb(tmp_4, view_4);
          view.fbb(p_3, view_3);
          view.jbb(tmp_3, view_3);
          this_0.fbb(p, view);
          return Unit_instance;
        });
        var tmp_1 = get_atEnd($this$col);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())($this$col.pc());
        var tmp0_elvis_lhs_3 = $this$col.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? $this$col : tmp0_elvis_lhs_3;
        $this$col.ebb(p_3, view_3);
        view_3.xbm(false);
        var tmp_2 = get_secondaryButton(view_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (Button())(view_3.pc());
        var tmp0_elvis_lhs_4 = view_3.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
        view_3.ebb(p_4, view_4);
        specCenteredText(view_4, 'Go Back');
        onClick(view_4, 'Dismiss', VOID, PayAppForm$SelectItemsDialog$render$slambda_2());
        view_3.fbb(p_4, view_4);
        view_3.jbb(tmp_2, view_4);
        var tmp_3 = get_primaryButton(view_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Button())(view_3.pc());
        var tmp0_elvis_lhs_5 = view_3.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
        view_3.ebb(p_5, view_5);
        var tmp_4 = KMutableProperty0();
        var tmp_5 = Button$_get_enabled_$ref_61t7nx(view_5);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('enabled', 0, tmp_4, tmp_5, Button$_set_enabled_$ref_o8kynz(view_5));
        reactiveScope(view_5, ($this$reactiveScope) => {
          var tmp$ret$65 = !equals($this$reactiveScope.baj(this.fhh_1), $this$reactiveScope.baj(this.ehh_1));
          this_0.set(tmp$ret$65);
          return Unit_instance;
        });
        specCenteredText_0(view_5, ($this$specCenteredText) => {
          var sel = $this$specCenteredText.baj(this.fhh_1);
          var prev = $this$specCenteredText.baj(this.ehh_1);
          var tmp$ret$67;
          $l$block: {
            // Inline function 'kotlin.collections.count' call
            var tmp;
            if (isInterface(sel, Collection())) {
              tmp = sel.i1();
            } else {
              tmp = false;
            }
            if (tmp) {
              tmp$ret$67 = 0;
              break $l$block;
            }
            var count = 0;
            var _iterator__ex2g4s = sel.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (!prev.t1(element)) {
                count = count + 1 | 0;
                checkCountOverflow(count);
              }
            }
            tmp$ret$67 = count;
          }
          var added = tmp$ret$67;
          var tmp$ret$69;
          $l$block_0: {
            // Inline function 'kotlin.collections.count' call
            var tmp_0;
            if (isInterface(prev, Collection())) {
              tmp_0 = prev.i1();
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              tmp$ret$69 = 0;
              break $l$block_0;
            }
            var count_0 = 0;
            var _iterator__ex2g4s_0 = prev.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var element_0 = _iterator__ex2g4s_0.o1();
              if (!sel.t1(element_0)) {
                count_0 = count_0 + 1 | 0;
                checkCountOverflow(count_0);
              }
            }
            tmp$ret$69 = count_0;
          }
          var removed = tmp$ret$69;
          return added > 0 && removed > 0 ? 'Add (' + added + '), Remove (' + removed + ')' : added > 0 ? 'Add (' + added + ') Draws' : removed > 0 ? 'Remove (' + removed + ') Draws' : 'Select Items';
        });
        onClick(view_5, 'Add Selected', VOID, PayAppForm$SelectItemsDialog$render$slambda_4(this, this.hhh_1));
        view_3.fbb(p_5, view_5);
        view_3.jbb(tmp_3, view_5);
        $this$col.fbb(p_3, view_3);
        $this$col.jbb(tmp_1, view_3);
        view_0.fbb(p_1, view_1);
        view_0.jbb(tmp_0, view_1);
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'SelectItemsDialog', VOID, VOID, [Page()]);
    SelectItemsDialogClass = $;
  }
  return SelectItemsDialogClass;
}
var PayAppItemFormClass;
function PayAppItemForm() {
  if (PayAppItemFormClass === VOID) {
    class $ {
      constructor(item, lineItem, retention, previousPayments, escrowBalanceLimit, pendingPayments, reportTo) {
        this.lhg_1 = item;
        this.mhg_1 = lineItem;
        this.nhg_1 = retention;
        this.ohg_1 = previousPayments;
        this.phg_1 = escrowBalanceLimit;
        this.qhg_1 = isPendingCompletion(this.mhg_1.kfy()) ? MonetaryValue__minus_impl_jw9qyp(this.mhg_1.v91(), this.ohg_1) : pendingPayments;
        this.rhg_1 = isComplete(this.mhg_1.kfy()) ? this.mhg_1.v91() : this.ohg_1;
        this.shg_1 = MonetaryValue__plus_impl_c1ylt(this.rhg_1, this.qhg_1);
        this.thg_1 = MonetaryValue__minus_impl_jw9qyp(this.mhg_1.v91(), this.shg_1);
        var tmp = this;
        var tmp0_safe_receiver = this.lhg_1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t6v_1;
        var tmp_0;
        var tmp_1 = tmp1_safe_receiver;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = null;
        } else {
          var tmp_2 = tmp1_safe_receiver;
          // Inline function 'kotlin.takeUnless' call
          var this_0 = tmp_2 == null ? null : new (MonetaryValue())(tmp_2);
          var tmp_3;
          var it = this_0.a5s_1;
          if (!(MonetaryValue__compareTo_impl_w7ul1r(it, Companion_instance.p91(0n)) <= 0)) {
            tmp_3 = this_0;
          } else {
            tmp_3 = null;
          }
          var tmp_4 = tmp_3;
          tmp_0 = tmp_4 == null ? null : tmp_4.a5s_1;
        }
        var tmp_5 = tmp_0;
        var tmp_6 = validated(Signal().fak(tmp_5 == null ? null : new (MonetaryValue())(tmp_5)), reportTo);
        tmp.uhg_1 = validate_0(tmp_6, VOID, (it) => it == null ? null : MonetaryValue__compareTo_impl_w7ul1r(it.a5s_1, Companion_instance.p91(0n)) < 0 ? 'Draw amount must be positive' : MonetaryValue__compareTo_impl_w7ul1r(this.thg_1, it.a5s_1) < 0 ? 'Draw cannot be greater than ' + MonetaryValue__toString_impl_xslc77(this.thg_1) : null);
        this.vhg_1 = !!(!(this.lhg_1 == null) & drawable(this.mhg_1.kfy()));
        var tmp_7 = this;
        tmp_7.whg_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(this.uhg_1);
          var tmp0_elvis_lhs = tmp == null ? null : tmp.a5s_1;
          var tmp_0;
          var tmp_1 = tmp0_elvis_lhs;
          if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
            tmp_0 = Companion_instance.p91(0n);
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          return coerceAtMost(new (MonetaryValue())(MonetaryValue__plus_impl_c1ylt(this.shg_1, tmp_0)), new (MonetaryValue())(this.mhg_1.v91()));
        });
      }
      jh7(saveIfNull, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_save__qhzefp.bind(VOID, this, saveIfNull), $completion);
      }
      nhh(saveIfNull, $completion, $super) {
        saveIfNull = saveIfNull === VOID ? false : saveIfNull;
        return $super === VOID ? this.jh7(saveIfNull, $completion) : $super.jh7.call(this, saveIfNull, $completion);
      }
      bhh(cache, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt.bind(VOID, this, cache), $completion);
      }
      dhi(writer) {
        // Inline function 'kotlin.with' call
        var tmp0 = this.mhg_1.kfy().b4_1;
        var lineItemStatus = tmp0 === 1 && !(this.lhg_1 == null) ? null : tmp0 === 2 && !(this.lhg_1 == null) ? null : tmp0 === 5 && !(this.lhg_1 == null) ? null : tmp0 === 12 || tmp0 === 13 || (tmp0 === 14 || tmp0 === 15) ? 'Paid' : tmp0 === 18 ? 'N/A' : get_increasedProjectPrice(this.mhg_1.hf9_1) ? 'Needs Funds' : 'Ineligible';
        var tmp;
        if (lineItemStatus === 'Ineligible') {
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (Frame())(writer.pc());
          var tmp0_elvis_lhs = writer.cbb_1;
          var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
          writer.ebb(p, view);
          var tmp_0 = view.ibb(get_centered(view), get_compact(view));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_0 = view.cbb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.ebb(p_0, view_0);
          view_0.xbm(false);
          view_0.zb8(get_rem_0(0.2));
          var tmp_1 = get_centered(view_0);
          var tmp0_0 = displayState(this.mhg_1.kfy()).b4_1;
          view_0.jbb(tmp_1, infoBubble(view_0, tmp0_0 === 4 ? 'Work item is currently in review' : 'Work item has not been started, or is not in the ' + LineItemState_InProgress_getInstance().j9b_1 + ' or ' + LineItemState_KeepWorking_getInstance().j9b_1 + ' status'));
          view_0.jbb(get_centered(view_0), smallBody(view_0, lineItemStatus));
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (Space())(view_0.pc(), 0.2);
          var tmp0_elvis_lhs_1 = view_0.cbb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
          view_0.ebb(p_1, view_1);
          view_0.fbb(p_1, view_1);
          view.fbb(p_0, view_0);
          view.jbb(tmp_0, view_0);
          writer.fbb(p, view);
          tmp = view;
        } else if (lineItemStatus === 'Needs Funds') {
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (Frame())(writer.pc());
          var tmp0_elvis_lhs_2 = writer.cbb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? writer : tmp0_elvis_lhs_2;
          writer.ebb(p_2, view_2);
          var tmp_2 = view_2.ibb(get_atCenterStart(view_2), get_compact(view_2));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (RowOrCol())(view_2.pc());
          var tmp0_elvis_lhs_3 = view_2.cbb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
          view_2.ebb(p_3, view_3);
          view_3.xbm(false);
          view_3.zb8(get_rem_0(0.2));
          view_3.jbb(get_centered(view_3), infoBubble(view_3, 'Client has not deposited all funds for accepted changes.'));
          view_3.jbb(get_centered(view_3), smallBody(view_3, lineItemStatus));
          view_2.fbb(p_3, view_3);
          view_2.jbb(tmp_2, view_3);
          writer.fbb(p_2, view_2);
          tmp = view_2;
        } else if (!(lineItemStatus == null)) {
          // Inline function 'com.crowpay.views.theming.smallBody' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (TextView())(writer.pc());
          var tmp0_elvis_lhs_4 = writer.cbb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? writer : tmp0_elvis_lhs_4;
          writer.ebb(p_4, view_4);
          view_4.jba(view_4.ob6_1.ybe(SmallBodySemantic_getInstance()));
          view_4.bbs(Align_Center_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var tmp_3 = view_4.tb5_1;
          var tmp_4;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(lineItemStatus) === 0) {
            tmp_4 = '\xA0';
          } else {
            tmp_4 = lineItemStatus;
          }
          tmp_3.fbu(tmp_4);
          writer.fbb(p_4, view_4);
          tmp = view_4;
        } else if (MonetaryValue__compareTo_impl_w7ul1r(MonetaryValue__minus_impl_jw9qyp(this.mhg_1.v91(), this.ohg_1), Companion_instance.p91(0n)) <= 0) {
          var tmp_5 = get_centered(writer);
          // Inline function 'com.crowpay.views.theming.smallBody' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_5 = new (TextView())(writer.pc());
          var tmp0_elvis_lhs_5 = writer.cbb_1;
          var p_5 = tmp0_elvis_lhs_5 == null ? writer : tmp0_elvis_lhs_5;
          writer.ebb(p_5, view_5);
          view_5.jba(view_5.ob6_1.ybe(SmallBodySemantic_getInstance()));
          view_5.bbs(Align_Center_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var value = 'Needs Sign Off';
          var tmp_6 = view_5.tb5_1;
          var tmp_7;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(value) === 0) {
            tmp_7 = '\xA0';
          } else {
            tmp_7 = value;
          }
          tmp_6.fbu(tmp_7);
          writer.fbb(p_5, view_5);
          tmp = writer.jbb(tmp_5, view_5);
        } else {
          tmp = null;
        }
        return tmp;
      }
      ehi(writer) {
        // Inline function 'kotlin.with' call
        var expanded = Signal().fak(false);
        var tmp = get_lightSection(writer);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(writer.pc());
        var tmp0_elvis_lhs = writer.cbb_1;
        var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
        writer.ebb(p, view);
        view.xbm(true);
        view.hba(view.kba().ib0_1.ed0(2));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.xbm(false);
        view_0.zb8(get_dp(3));
        var tmp_0 = view_0.ibb(get_centered(view_0), get_expanding(view_0));
        view_0.jbb(tmp_0, leftExpandButton(view_0, expanded, false, VOID, VOID, VOID, ($this$leftExpandButton) => {
          $this$leftExpandButton.jbb($this$leftExpandButton.ibb(get_expanding($this$leftExpandButton), get_centered($this$leftExpandButton)), bodyBold($this$leftExpandButton, this.mhg_1.lf9_1));
          return Unit_instance;
        }));
        view_0.jbb(view_0.ibb(view_0.ibb(get_centered(view_0), sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, get_rem(8))), get_centered(view_0)), drawInput(this, view_0));
        view.fbb(p_0, view_0);
        var tmp_1 = view.ibb(shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(expanded)), get_padded(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_1 = view.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.ebb(p_1, view_1);
        view_1.xbm(true);
        tableEntryUnderlinedString(view_1, 'Approved Amount', MonetaryValue__toString_impl_xslc77(this.mhg_1.v91()));
        tableEntryUnderlinedString(view_1, 'Processed', MonetaryValue__toString_impl_xslc77(this.rhg_1));
        tableEntryUnderlinedString(view_1, 'Pending', MonetaryValue__toString_impl_xslc77(this.qhg_1));
        // Inline function 'com.crowpay.views.components.tableEntryUnderlined' call
        var key = 'Work Completed';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        view_2.xbm(true);
        view_2.zb8(get_dp(1));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.ebb(p_3, view_3);
        view_3.xbm(false);
        view_3.zb8(get_rem_0(0.5));
        view_3.jbb(get_expanding(view_3), body(view_3, key));
        workCompleted(this, view_3);
        view_2.fbb(p_3, view_3);
        greySeparator(view_2);
        view_1.fbb(p_2, view_2);
        tableEntryUnderlinedString_0(view_1, 'Remaining', ($this$tableEntryUnderlinedString) => MonetaryValue__toString_impl_xslc77(MonetaryValue__minus_impl_jw9qyp(this.mhg_1.v91(), $this$tableEntryUnderlinedString.baj(this.whg_1).a5s_1)));
        tableEntryUnderlinedString_0(view_1, 'Retention', ($this$tableEntryUnderlinedString) => MonetaryValue__toString_impl_xslc77(MonetaryValue__times_impl_hlr6p7($this$tableEntryUnderlinedString.baj(this.whg_1).a5s_1, this.nhg_1)));
        view.fbb(p_1, view_1);
        view.jbb(tmp_1, view_1);
        writer.fbb(p, view);
        return writer.jbb(tmp, view);
      }
      chi(writer, columns) {
        // Inline function 'kotlin.with' call
        // Inline function 'kotlin.with' call
        var tmp = sizeConstraints(writer, VOID, VOID, VOID, VOID, VOID, VOID, get_rem_0(1.5));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(writer.pc());
        var tmp0_elvis_lhs = writer.cbb_1;
        var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
        writer.ebb(p, view);
        view.xbm(false);
        view.zb8(get_px(0));
        var tmp_0 = view.ibb(columns.ng6(view), get_centered(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.xbm(false);
        view_0.zb8(get_AppDimensions().mg2_1);
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (TextView())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance()));
        if (this.mhg_1.kfy().equals(LineItemState_Cancelled_getInstance())) {
          view_1.jba(view_1.ob6_1.ybe(GreyedOutSemantic_getInstance()));
        }
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value = this.mhg_1.lf9_1;
        var tmp_1 = view_1.tb5_1;
        var tmp_2;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value) === 0) {
          tmp_2 = '\xA0';
        } else {
          tmp_2 = value;
        }
        tmp_1.fbu(tmp_2);
        view_0.fbb(p_1, view_1);
        var tmp_3 = get_centered(view_0);
        // Inline function 'com.crowpay.views.theming.smallBody' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (TextView())(view_0.pc());
        var tmp0_elvis_lhs_2 = view_0.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
        view_0.ebb(p_2, view_2);
        view_2.jba(view_2.ob6_1.ybe(SmallBodySemantic_getInstance()));
        var tmp_4 = KMutableProperty0();
        var tmp_5 = TextView$_get_content_$ref_4pzcwl_1(view_2);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_1(view_2));
        reactiveScope(view_2, ($this$reactiveScope) => {
          var tmp0_safe_receiver = this.mhg_1.z94();
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f95_1;
          var tmp$ret$7 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
          this_0.set(tmp$ret$7);
          return Unit_instance;
        });
        view_0.fbb(p_2, view_2);
        view_0.jbb(tmp_3, view_2);
        view.fbb(p_0, view_0);
        view.jbb(tmp_0, view_0);
        var tmp_6 = weight(view, sum(drop(columns.ig6_1, 1)));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_3 = view.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
        view.ebb(p_3, view_3);
        view_3.xbm(false);
        view_3.zb8(columns.kg6_1);
        if (!this.vhg_1) {
          view_3.jba(view_3.ob6_1.ybe(GreyedOutSemantic_getInstance()));
        }
        var tmp_7 = view_3.ibb(columns.ng6(view_3), get_centered(view_3));
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (TextView())(view_3.pc());
        var tmp0_elvis_lhs_4 = view_3.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
        view_3.ebb(p_4, view_4);
        view_4.jba(view_4.ob6_1.ybe(BodySemantic_getInstance()));
        view_4.bbs(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value_0 = MonetaryValue__toString_impl_xslc77(this.mhg_1.v91());
        var tmp_8 = view_4.tb5_1;
        var tmp_9;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value_0) === 0) {
          tmp_9 = '\xA0';
        } else {
          tmp_9 = value_0;
        }
        tmp_8.fbu(tmp_9);
        view_3.fbb(p_4, view_4);
        view_3.jbb(tmp_7, view_4);
        var tmp_10 = view_3.ibb(columns.ng6(view_3), get_centered(view_3));
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (TextView())(view_3.pc());
        var tmp0_elvis_lhs_5 = view_3.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
        view_3.ebb(p_5, view_5);
        view_5.jba(view_5.ob6_1.ybe(BodySemantic_getInstance()));
        view_5.bbs(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value_1 = MonetaryValue__toString_impl_xslc77(this.rhg_1);
        var tmp_11 = view_5.tb5_1;
        var tmp_12;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value_1) === 0) {
          tmp_12 = '\xA0';
        } else {
          tmp_12 = value_1;
        }
        tmp_11.fbu(tmp_12);
        view_3.fbb(p_5, view_5);
        view_3.jbb(tmp_10, view_5);
        var tmp_13 = view_3.ibb(columns.ng6(view_3), get_centered(view_3));
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (TextView())(view_3.pc());
        var tmp0_elvis_lhs_6 = view_3.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_3 : tmp0_elvis_lhs_6;
        view_3.ebb(p_6, view_6);
        view_6.jba(view_6.ob6_1.ybe(BodySemantic_getInstance()));
        view_6.bbs(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value_2 = MonetaryValue__toString_impl_xslc77(this.qhg_1);
        var tmp_14 = view_6.tb5_1;
        var tmp_15;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value_2) === 0) {
          tmp_15 = '\xA0';
        } else {
          tmp_15 = value_2;
        }
        tmp_14.fbu(tmp_15);
        view_3.fbb(p_6, view_6);
        view_3.jbb(tmp_13, view_6);
        var tmp_16 = view_3.ibb(columns.ng6(view_3), get_centered(view_3));
        var tmp0_elvis_lhs_7 = this.dhi(view_3);
        view_3.jbb(tmp_16, tmp0_elvis_lhs_7 == null ? drawInput(this, view_3) : tmp0_elvis_lhs_7);
        var tmp_17 = columns.ng6(view_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (Frame())(view_3.pc());
        var tmp0_elvis_lhs_8 = view_3.cbb_1;
        var p_7 = tmp0_elvis_lhs_8 == null ? view_3 : tmp0_elvis_lhs_8;
        view_3.ebb(p_7, view_7);
        view_7.jbb(get_centered(view_7), workCompleted(this, view_7));
        view_3.fbb(p_7, view_7);
        view_3.jbb(tmp_17, view_7);
        var tmp_18 = view_3.ibb(columns.ng6(view_3), get_centered(view_3));
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (TextView())(view_3.pc());
        var tmp0_elvis_lhs_9 = view_3.cbb_1;
        var p_8 = tmp0_elvis_lhs_9 == null ? view_3 : tmp0_elvis_lhs_9;
        view_3.ebb(p_8, view_8);
        view_8.jba(view_8.ob6_1.ybe(BodySemantic_getInstance()));
        view_8.bbs(Align_Center_getInstance());
        var tmp_19 = KMutableProperty0();
        var tmp_20 = TextView$_get_content_$ref_4pzcwl_2(view_8);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('content', 0, tmp_19, tmp_20, TextView$_set_content_$ref_pketfb_2(view_8));
        reactiveScope(view_8, ($this$reactiveScope) => {
          var tmp$ret$42 = MonetaryValue__toString_impl_xslc77(MonetaryValue__minus_impl_jw9qyp(this.mhg_1.v91(), $this$reactiveScope.baj(this.whg_1).a5s_1));
          this_1.set(tmp$ret$42);
          return Unit_instance;
        });
        view_3.fbb(p_8, view_8);
        view_3.jbb(tmp_18, view_8);
        var tmp_21 = view_3.ibb(columns.ng6(view_3), get_centered(view_3));
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (TextView())(view_3.pc());
        var tmp0_elvis_lhs_10 = view_3.cbb_1;
        var p_9 = tmp0_elvis_lhs_10 == null ? view_3 : tmp0_elvis_lhs_10;
        view_3.ebb(p_9, view_9);
        view_9.jba(view_9.ob6_1.ybe(BodySemantic_getInstance()));
        view_9.bbs(Align_Center_getInstance());
        var tmp_22 = KMutableProperty0();
        var tmp_23 = TextView$_get_content_$ref_4pzcwl_3(view_9);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_2 = getPropertyCallableRef('content', 0, tmp_22, tmp_23, TextView$_set_content_$ref_pketfb_3(view_9));
        reactiveScope(view_9, ($this$reactiveScope) => {
          var tmp$ret$49 = MonetaryValue__toString_impl_xslc77(MonetaryValue__times_impl_hlr6p7($this$reactiveScope.baj(this.whg_1).a5s_1, this.nhg_1));
          this_2.set(tmp$ret$49);
          return Unit_instance;
        });
        view_3.fbb(p_9, view_9);
        view_3.jbb(tmp_21, view_9);
        view.fbb(p_3, view_3);
        view.jbb(tmp_6, view_3);
        writer.fbb(p, view);
        return writer.jbb(tmp, view);
      }
    }
    initMetadataForClass($, 'PayAppItemForm', VOID, VOID, VOID, [1]);
    PayAppItemFormClass = $;
  }
  return PayAppItemFormClass;
}
var sam$kotlin_Comparator$0Class_0;
function sam$kotlin_Comparator$0_0() {
  if (sam$kotlin_Comparator$0Class_0 === VOID) {
    class $ {
      constructor(function_0) {
        this.fhi_1 = function_0;
      }
      wi(a, b) {
        return this.fhi_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.fhi_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class_0 = $;
  }
  return sam$kotlin_Comparator$0Class_0;
}
var sam$kotlin_Comparator$0Class_1;
function sam$kotlin_Comparator$0_1() {
  if (sam$kotlin_Comparator$0Class_1 === VOID) {
    class $ {
      constructor(function_0) {
        this.ghi_1 = function_0;
      }
      wi(a, b) {
        return this.ghi_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.ghi_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class_1 = $;
  }
  return sam$kotlin_Comparator$0Class_1;
}
var sam$kotlin_Comparator$0Class_2;
function sam$kotlin_Comparator$0_2() {
  if (sam$kotlin_Comparator$0Class_2 === VOID) {
    class $ {
      constructor(function_0) {
        this.hhi_1 = function_0;
      }
      wi(a, b) {
        return this.hhi_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.hhi_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class_2 = $;
  }
  return sam$kotlin_Comparator$0Class_2;
}
var sam$kotlin_Comparator$0Class_3;
function sam$kotlin_Comparator$0_3() {
  if (sam$kotlin_Comparator$0Class_3 === VOID) {
    class $ {
      constructor(function_0) {
        this.ihi_1 = function_0;
      }
      wi(a, b) {
        return this.ihi_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.ihi_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class_3 = $;
  }
  return sam$kotlin_Comparator$0Class_3;
}
var sam$kotlin_Comparator$0Class_4;
function sam$kotlin_Comparator$0_4() {
  if (sam$kotlin_Comparator$0Class_4 === VOID) {
    class $ {
      constructor(function_0) {
        this.jhi_1 = function_0;
      }
      wi(a, b) {
        return this.jhi_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.jhi_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class_4 = $;
  }
  return sam$kotlin_Comparator$0Class_4;
}
function actionBar$saveButton(_this__u8e3s4, this$0) {
  var tmp = get_secondaryButton(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  specCenteredText(view, 'Save');
  view.mbg(Action('Save', VOID, PayAppForm$actionBar$saveButton$slambda_0(this$0)));
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function actionBar$saveAndCloseButton(_this__u8e3s4, this$0) {
  var tmp = get_secondaryButton(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  specCenteredText(view, 'Save & Close');
  view.mbg(Action('Save and Exit', VOID, PayAppForm$actionBar$saveAndCloseButton$slambda_0(this$0, view)));
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function actionBar$discardButton(_this__u8e3s4, this$0) {
  var tmp = get_deleteButton(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  specCenteredText(view, 'Discard');
  onClick(view, 'Discard Draft', VOID, PayAppForm$actionBar$discardButton$slambda_0(this$0, view));
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function actionBar$deleteButton(_this__u8e3s4, this$0) {
  var tmp = _this__u8e3s4.ibb(shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => $this$shownWhen.baj(this$0.gf4_1).m6y_1 == null), get_deleteButton(_this__u8e3s4));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.jbb(get_centered(view), icon(view, resize(get_trash(Companion_getInstance()), get_rem_0(1.2)), 'Delete Draft'));
  onClick(view, VOID, VOID, PayAppForm$actionBar$deleteButton$slambda_0(this$0, view));
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function actionBar$submitButton(_this__u8e3s4, this$0) {
  var tmp = get_primaryButton(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  var tmp_0 = KMutableProperty0();
  var tmp_1 = Button$_get_enabled_$ref_61t7nx_0(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('enabled', 0, tmp_0, tmp_1, Button$_set_enabled_$ref_o8kynz_0(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp$ret$0 = MonetaryValue__compareTo_impl_w7ul1r($this$reactiveScope.baj(this$0.yf4_1).a5s_1, Companion_instance.p91(0n)) > 0 && $this$reactiveScope.baj(this$0.ff4_1.pat_1).i1();
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  specCenteredText(view, 'Submit');
  onClick(view, 'Submit', VOID, PayAppForm$actionBar$submitButton$slambda_0(view, this$0));
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function drawSummary$_anonymous_$projectValueStatement_5ban4y(_this__u8e3s4, rowSpacing, this$0) {
  var tmp = sizeConstraints(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, get_rem(25));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(rowSpacing);
  drawSummary$_anonymous_$projectValueStatement$tableRow_7chufi(view, 'Original Project Price', ($this$tableRow) => MonetaryValue__toString_impl_xslc77($this$tableRow.baj(this$0.hf4_1).x7b_1));
  drawSummary$_anonymous_$projectValueStatement$tableRow_7chufi(view, 'Accepted Change Amount', ($this$tableRow) => {
    // Inline function 'kotlin.let' call
    var it = $this$tableRow.baj(this$0.hf4_1);
    var tmp$ret$1 = MonetaryValue__minus_impl_jw9qyp(it.y7b_1, it.x7b_1);
    return MonetaryValue__toString_impl_xslc77(tmp$ret$1);
  });
  drawSummary$_anonymous_$projectValueStatement$tableRow_7chufi(view, 'Active Price', ($this$tableRow) => MonetaryValue__toString_impl_xslc77($this$tableRow.baj(this$0.hf4_1).y7b_1));
  drawSummary$_anonymous_$projectValueStatement$tableRow_7chufi(view, 'Retention', ($this$tableRow) => {
    // Inline function 'kotlin.math.roundToInt' call
    var this_0 = $this$tableRow.baj(this$0.hf4_1).u97() * 100;
    return '' + roundToInt(this_0) + '%';
  });
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function drawSummary$_anonymous_$projectValueStatement$tableRow_7chufi(_this__u8e3s4, key, value) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_px(0));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  view_0.jbb(get_expanding(view_0), body(view_0, key));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance()));
  view_1.bbs(Align_Center_getInstance());
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl_11(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_11(view_1));
  var actionToCalculate = value;
  reactiveScope(view_1, ($this$reactiveScope) => {
    this_0.set(actionToCalculate($this$reactiveScope));
    return Unit_instance;
  });
  view_0.fbb(p_1, view_1);
  view.fbb(p_0, view_0);
  greySeparator(view);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function drawSummary$_anonymous_$totalDrawsToDate_i4i7rn(_this__u8e3s4, rowSpacing, this$0) {
  var keyWeight = 2.5;
  var valueWeight = 1.25;
  var valueSpacing = get_dp(4);
  var tmp = sizeConstraints(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, get_rem(25));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(minus_0(rowSpacing, valueSpacing));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  view_0.jbb(view_0.ibb(weight(view_0, keyWeight), get_centered(view_0)), body(view_0, 'Work Completed to Date'));
  var tmp_0 = view_0.ibb(weight(view_0, valueWeight), get_lightSection(view_0));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Frame())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.eba(valueSpacing);
  view_1.zb8(valueSpacing);
  var tmp_1 = get_centered(view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.ebb(p_2, view_2);
  view_2.xbm(false);
  view_2.zb8(get_dp(5));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextView())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.ebb(p_3, view_3);
  view_3.jba(view_3.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl_12(view_3);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb_12(view_3));
  reactiveScope(view_3, ($this$reactiveScope) => {
    var tmp$ret$0 = MonetaryValue__toString_impl_xslc77($this$reactiveScope.baj(this$0.zf4_1).a5s_1);
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  view_2.fbb(p_3, view_3);
  var tmp_4 = get_centered(view_2);
  // Inline function 'com.crowpay.views.theming.smallBody' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (TextView())(view_2.pc());
  var tmp0_elvis_lhs_4 = view_2.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
  view_2.ebb(p_4, view_4);
  view_4.jba(view_4.ob6_1.ybe(SmallBodySemantic_getInstance()));
  var tmp_5 = KMutableProperty0();
  var tmp_6 = TextView$_get_content_$ref_4pzcwl_13(view_4);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb_13(view_4));
  reactiveScope(view_4, ($this$reactiveScope) => {
    var price = $this$reactiveScope.baj(this$0.hf4_1).y7b_1;
    var tmp$ret$7 = '(' + renderPercent(percentComplete($this$reactiveScope.baj(this$0.zf4_1).a5s_1, price)) + ')';
    this_1.set(tmp$ret$7);
    return Unit_instance;
  });
  view_2.fbb(p_4, view_4);
  view_2.jbb(tmp_4, view_4);
  view_1.fbb(p_2, view_2);
  view_1.jbb(tmp_1, view_2);
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_0, view_1);
  view.fbb(p_0, view_0);
  drawSummary$_anonymous_$totalDrawsToDate$tableRow$0_u4ugzz(view, keyWeight, valueWeight, valueSpacing, 'Less Retention To Date', ($this$tableRow) => {
    var p = $this$tableRow.baj(this$0.hf4_1);
    var thisDraw = $this$tableRow.baj(this$0.yf4_1).a5s_1;
    return MonetaryValue__toString_impl_xslc77(MonetaryValue__plus_impl_c1ylt(MonetaryValue__minus_impl_jw9qyp(MonetaryValue__minus_impl_jw9qyp($this$tableRow.baj(this$0.zf4_1).a5s_1, thisDraw), p.e7c_1), MonetaryValue__times_impl_hlr6p7(thisDraw, p.u97())));
  });
  drawSummary$_anonymous_$totalDrawsToDate$tableRow$0_u4ugzz(view, keyWeight, valueWeight, valueSpacing, 'Less Previous Payments', ($this$tableRow) => MonetaryValue__toString_impl_xslc77($this$tableRow.baj(this$0.hf4_1).e7c_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (Separator())(view.pc());
  var tmp0_elvis_lhs_5 = view.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view : tmp0_elvis_lhs_5;
  view.ebb(p_5, view_5);
  view.fbb(p_5, view_5);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_6 = view.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view : tmp0_elvis_lhs_6;
  view.ebb(p_6, view_6);
  view_6.xbm(false);
  view_6.jbb(view_6.ibb(weight(view_6, keyWeight), get_centered(view_6)), body(view_6, '= Amount Due Request'));
  var tmp_7 = view_6.ibb(view_6.ibb(weight(view_6, valueWeight), get_lightSection(view_6)), get_redText(view_6));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (TextView())(view_6.pc());
  var tmp0_elvis_lhs_7 = view_6.cbb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
  view_6.ebb(p_7, view_7);
  view_7.jba(view_7.ob6_1.ybe(BodySemantic_getInstance()));
  view_7.zb8(valueSpacing);
  view_7.eba(valueSpacing);
  view_7.bbs(Align_Center_getInstance());
  var tmp_8 = KMutableProperty0();
  var tmp_9 = TextView$_get_content_$ref_4pzcwl_14(view_7);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb_14(view_7));
  reactiveScope(view_7, ($this$reactiveScope) => {
    var tmp$ret$28 = MonetaryValue__toString_impl_xslc77(MonetaryValue__times_impl_hlr6p7($this$reactiveScope.baj(this$0.yf4_1).a5s_1, 1 - $this$reactiveScope.baj(this$0.hf4_1).u97()));
    this_2.set(tmp$ret$28);
    return Unit_instance;
  });
  view_6.fbb(p_7, view_7);
  view_6.jbb(tmp_7, view_7);
  view.fbb(p_6, view_6);
  _this__u8e3s4.fbb(p, view);
  _this__u8e3s4.jbb(tmp, view);
}
function drawSummary$_anonymous_$totalDrawsToDate$tableRow$0_u4ugzz(_this__u8e3s4, keyWeight, valueWeight, valueSpacing, key, value) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(false);
  view.jbb(view.ibb(weight(view, keyWeight), get_centered(view)), body(view, key));
  var tmp = view.ibb(weight(view, valueWeight), get_lightSection(view));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.jba(view_0.ob6_1.ybe(BodySemantic_getInstance()));
  view_0.zb8(valueSpacing);
  view_0.eba(valueSpacing);
  view_0.bbs(Align_Center_getInstance());
  var tmp_0 = KMutableProperty0();
  var tmp_1 = TextView$_get_content_$ref_4pzcwl_15(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_15(view_0));
  var actionToCalculate = value;
  reactiveScope(view_0, ($this$reactiveScope) => {
    this_0.set(actionToCalculate($this$reactiveScope));
    return Unit_instance;
  });
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  _this__u8e3s4.fbb(p, view);
}
function table$_anonymous_$_anonymous_$_anonymous_$_anonymous_$columnLabel_3d0u44(_this__u8e3s4, info, content) {
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  var tmp = get_centered(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  view_0.zb8(get_dp(5));
  view_0.jbb(get_centered(view_0), infoBubble(view_0, info));
  view_0.jbb(get_centered(view_0), content(view_0));
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Space())(view_0.pc(), 0.0);
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_0.fbb(p_1, view_1);
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function table$_anonymous_$_anonymous_$_anonymous_$_anonymous_$columnLabel$0_y99dyg(_this__u8e3s4, name, info) {
  return table$_anonymous_$_anonymous_$_anonymous_$_anonymous_$columnLabel_3d0u44(_this__u8e3s4, info, ($this$columnLabel) => {
    // Inline function 'com.crowpay.views.theming.bodyBold' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (TextView())($this$columnLabel.pc());
    var tmp0_elvis_lhs = $this$columnLabel.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$columnLabel : tmp0_elvis_lhs;
    $this$columnLabel.ebb(p, view);
    view.jba(view.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
    view.yco(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var value = name;
    var tmp = view.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(value) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = value;
    }
    tmp.fbu(tmp_0);
    $this$columnLabel.fbb(p, view);
    return view;
  });
}
function table$_anonymous_$_anonymous_$_anonymous_$_anonymous_$total_a0lejy(_this__u8e3s4, calculation) {
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.jba(view.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  view.bbs(Align_Center_getInstance());
  view.yco(true);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl_16(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_16(view));
  reactiveScope(view, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp$ret$0 = calculation($this$reactiveScope).a5s_1;
    var tmp$ret$1 = MonetaryValue__toString_impl_xslc77(tmp$ret$0);
    this_0.set(tmp$ret$1);
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p, view);
  return view;
}
function table$_anonymous_$_anonymous_$money_3n1w1o(_this__u8e3s4, calculation) {
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
  view.bbs(Align_Center_getInstance());
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl_17(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_17(view));
  reactiveScope(view, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp$ret$0 = calculation($this$reactiveScope).a5s_1;
    var tmp$ret$1 = MonetaryValue__toString_impl_xslc77(tmp$ret$0);
    this_0.set(tmp$ret$1);
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p, view);
  return view;
}
var PayAppForm$escrowBalanceLimit$1Class;
function PayAppForm$escrowBalanceLimit$1() {
  if (PayAppForm$escrowBalanceLimit$1Class === VOID) {
    class $ {
      constructor(this$0) {
        var tmp = this;
        // Inline function 'kotlin.apply' call
        var this_0 = this$0.ff4_1.tat();
        validateReactive(this_0, ($this$validateReactive) => {
          var max = $this$validateReactive.baj(this$0.tf4_1).a5s_1;
          return MonetaryValue__compareTo_impl_w7ul1r($this$validateReactive.baj(this$0.yf4_1).a5s_1, max) > 0 ? 'Draw exceeds the current maximum drawable amount of ' + MonetaryValue__toString_impl_xslc77(max) + '. Have the client deposit remaining funds to draw more.' : null;
        });
        tmp.khi_1 = this_0;
      }
      vat() {
        return this.khi_1;
      }
    }
    initMetadataForClass($);
    PayAppForm$escrowBalanceLimit$1Class = $;
  }
  return PayAppForm$escrowBalanceLimit$1Class;
}
function PayAppForm$existingItemForms$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.mhg_1.hf9_1;
  var tmp$ret$1 = b.mhg_1.hf9_1;
  return compareValues(tmp, tmp$ret$1);
}
function PayAppForm$missingItemForms$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.mhg_1.hf9_1;
  var tmp$ret$1 = b.mhg_1.hf9_1;
  return compareValues(tmp, tmp$ret$1);
}
function PayAppForm$allItemForms$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.mhg_1.hf9_1;
  var tmp$ret$1 = b.mhg_1.hf9_1;
  return compareValues(tmp, tmp$ret$1);
}
var PayAppForm$save$slambdaClass;
function PayAppForm$save$slambda() {
  if (PayAppForm$save$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.lhh_1 = this$0;
      }
      lhi(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.lhi(p1 instanceof PayApplication() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    PayAppForm$save$slambdaClass = $;
  }
  return PayAppForm$save$slambdaClass;
}
function PayAppForm$save$slambda_0(this$0) {
  var i = new (PayAppForm$save$slambda())(this$0);
  var l = (it, $completion) => i.lhi(it, $completion);
  l.$arity = 1;
  return l;
}
var PayAppForm$save$slambdaClass_0;
function PayAppForm$save$slambda_1() {
  if (PayAppForm$save$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.ohh_1 = this$0;
      }
      wah($this$coroutineScope, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this, $this$coroutineScope), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    PayAppForm$save$slambdaClass_0 = $;
  }
  return PayAppForm$save$slambdaClass_0;
}
function PayAppForm$save$slambda_2(this$0) {
  var i = new (PayAppForm$save$slambda_1())(this$0);
  var l = ($this$coroutineScope, $completion) => i.wah($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
var PayAppForm$descriptionInput$slambdaClass;
function PayAppForm$descriptionInput$slambda() {
  if (PayAppForm$descriptionInput$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    PayAppForm$descriptionInput$slambdaClass = $;
  }
  return PayAppForm$descriptionInput$slambdaClass;
}
function PayAppForm$descriptionInput$slambda_0() {
  var i = new (PayAppForm$descriptionInput$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_5(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_5(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function PayAppForm$table$lambda$lambda($this$columnLabel) {
  bodyBold($this$columnLabel, 'Work To-Date');
  return smallBody($this$columnLabel, '(%)');
}
function TextView$_get_content_$ref_4pzcwl_6(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_6(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function PayAppForm$table$lambda$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp0_safe_receiver = a.af_1;
  var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k7z_1;
  var tmp0_safe_receiver_0 = b.af_1;
  var tmp$ret$1 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.k7z_1;
  return compareValues(tmp, tmp$ret$1);
}
function TextView$_get_content_$ref_4pzcwl_7(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_7(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_8(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_8(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_9(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_9(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_10(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_10(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var PayAppForm$drawCards$slambdaClass;
function PayAppForm$drawCards$slambda() {
  if (PayAppForm$drawCards$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.mhi_1 = this$0;
      }
      sao($completion) {
        get_dialogStack().xgd(new (SelectItemsDialog())(this.mhi_1));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    PayAppForm$drawCards$slambdaClass = $;
  }
  return PayAppForm$drawCards$slambdaClass;
}
function PayAppForm$drawCards$slambda_0(this$0) {
  var i = new (PayAppForm$drawCards$slambda())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function PayAppForm$drawCards$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp0_safe_receiver = a.af_1;
  var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m7z_1;
  var tmp0_safe_receiver_0 = b.af_1;
  var tmp$ret$1 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.m7z_1;
  return compareValues(tmp, tmp$ret$1);
}
function PayAppForm$drawCards$lambda($this$forEach, _destruct__k2r9zo) {
  var scope = _destruct__k2r9zo.cf();
  var items = _destruct__k2r9zo.df();
  var tmp = $this$forEach.hbb(ListSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$forEach.pc());
  var tmp0_elvis_lhs = $this$forEach.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$forEach : tmp0_elvis_lhs;
  $this$forEach.ebb(p, view);
  view.xbm(true);
  if (!(scope == null)) {
    var tmp_0 = get_compact(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.xbm(false);
    if (scope.p7z_1) {
      view_0.jbb(get_centered(view_0), scopeSetIcon(view_0, get_rem_0(1.2)));
    }
    view_0.jbb(get_centered(view_0), bodyBold(view_0, scope.m7z_1));
    view.fbb(p_0, view_0);
    view.jbb(tmp_0, view_0);
  }
  var _iterator__ex2g4s = items.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    item.ehi(view);
  }
  $this$forEach.fbb(p, view);
  $this$forEach.jbb(tmp, view);
  return Unit_instance;
}
var PayAppForm$actionBar$saveButton$slambdaClass;
function PayAppForm$actionBar$saveButton$slambda() {
  if (PayAppForm$actionBar$saveButton$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.qhh_1 = this$0;
      }
      wah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    PayAppForm$actionBar$saveButton$slambdaClass = $;
  }
  return PayAppForm$actionBar$saveButton$slambdaClass;
}
function PayAppForm$actionBar$saveButton$slambda_0(this$0) {
  var i = new (PayAppForm$actionBar$saveButton$slambda())(this$0);
  var l = ($this$Action, $completion) => i.wah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
var PayAppForm$actionBar$saveAndCloseButton$slambdaClass;
function PayAppForm$actionBar$saveAndCloseButton$slambda() {
  if (PayAppForm$actionBar$saveAndCloseButton$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.rhh_1 = this$0;
        this.shh_1 = $$this$button;
      }
      wah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    PayAppForm$actionBar$saveAndCloseButton$slambdaClass = $;
  }
  return PayAppForm$actionBar$saveAndCloseButton$slambdaClass;
}
function PayAppForm$actionBar$saveAndCloseButton$slambda_0(this$0, $$this$button) {
  var i = new (PayAppForm$actionBar$saveAndCloseButton$slambda())(this$0, $$this$button);
  var l = ($this$Action, $completion) => i.wah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
var PayAppForm$actionBar$discardButton$slambdaClass;
function PayAppForm$actionBar$discardButton$slambda() {
  if (PayAppForm$actionBar$discardButton$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.nhi_1 = this$0;
        this.ohi_1 = $$this$button;
      }
      sao($completion) {
        var tmp = get_dialogStack();
        tmp.xgd(new (GenericConfirmationDialog())('Discard Work', 'Are you sure you want to discard? Any unsaved changes will be lost.', VOID, 'Discard', VOID, VOID, VOID, VOID, VOID, VOID, PayAppForm$actionBar$discardButton$slambda$slambda_0(this.nhi_1, this.ohi_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    PayAppForm$actionBar$discardButton$slambdaClass = $;
  }
  return PayAppForm$actionBar$discardButton$slambdaClass;
}
function PayAppForm$actionBar$discardButton$slambda_0(this$0, $$this$button) {
  var i = new (PayAppForm$actionBar$discardButton$slambda())(this$0, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var PayAppForm$actionBar$deleteButton$slambdaClass;
function PayAppForm$actionBar$deleteButton$slambda() {
  if (PayAppForm$actionBar$deleteButton$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.phi_1 = this$0;
        this.qhi_1 = $$this$button;
      }
      sao($completion) {
        var tmp = get_dialogStack();
        var tmp_0 = DangerButtonSemantic_getInstance();
        tmp.xgd(new (GenericConfirmationDialog())('Delete Draft?', 'You are about to delete this draw draft. Deleted drafts cannot be recovered. Delete this draft?', VOID, 'Delete Draft', VOID, tmp_0, VOID, VOID, VOID, VOID, PayAppForm$actionBar$deleteButton$slambda$slambda_0(this.phi_1, this.qhi_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    PayAppForm$actionBar$deleteButton$slambdaClass = $;
  }
  return PayAppForm$actionBar$deleteButton$slambdaClass;
}
function PayAppForm$actionBar$deleteButton$slambda_0(this$0, $$this$button) {
  var i = new (PayAppForm$actionBar$deleteButton$slambda())(this$0, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var PayAppForm$actionBar$submitButton$slambdaClass;
function PayAppForm$actionBar$submitButton$slambda() {
  if (PayAppForm$actionBar$submitButton$slambdaClass === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.ahi_1 = $$this$button;
        this.bhi_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    PayAppForm$actionBar$submitButton$slambdaClass = $;
  }
  return PayAppForm$actionBar$submitButton$slambdaClass;
}
function PayAppForm$actionBar$submitButton$slambda_0($$this$button, this$0) {
  var i = new (PayAppForm$actionBar$submitButton$slambda())($$this$button, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_11(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_11(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_12(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_12(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_13(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_13(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_14(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_14(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_15(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_15(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_16(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_16(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_17(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_17(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function Section_Summary_getInstance() {
  Section_initEntries();
  return Section_Summary_instance;
}
function Section_Draws_getInstance() {
  Section_initEntries();
  return Section_Draws_instance;
}
var PayAppFormClass;
function PayAppForm() {
  if (PayAppFormClass === VOID) {
    class $ {
      constructor(payAppID) {
        this.ef4_1 = payAppID;
        this.ff4_1 = new (IssueNode())(null);
        var tmp = this;
        tmp.gf4_1 = validated_0(Draft(($this$Draft) => {
          var tmp0_elvis_lhs = $this$Draft.baj($this$Draft.baj(get_session()).afw_1.kft(this.ef4_1));
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw NotFound().nfx(getKClass(PayApplication()), null);
          } else {
            tmp = tmp0_elvis_lhs;
          }
          return tmp;
        }), this.ff4_1);
        var tmp_0 = this;
        tmp_0.hf4_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0_elvis_lhs = $this$remember.baj($this$remember.baj(get_session()).pfv_1.kft($this$remember.baj(this.gf4_1).j6y_1));
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw NotFound().nfx(getKClass(Project()), null);
          } else {
            tmp = tmp0_elvis_lhs;
          }
          return tmp;
        });
        var tmp_1 = this;
        tmp_1.if4_1 = remember(VOID, VOID, VOID, ($this$remember) => 'Draw ' + $this$remember.baj(this.gf4_1).k6y_1);
        this.jf4_1 = MemberRole_Manager_getInstance();
        var tmp_2 = this;
        tmp_2.kf4_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).mfv_1;
          var tmp0_limit = 2147483647;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
          var tmp$ret$0 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$0);
          var tmp1_condition = eq(get_project_1(it), $this$remember.baj(this.hf4_1).x7a_1);
          return tmp.feo(new (Query())(tmp1_condition, VOID, VOID, tmp0_limit));
        });
        var tmp_3 = this;
        tmp_3.lf4_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).nfv_1;
          var tmp0_limit = 2147483647;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ItemChange()), arrayOf([]), false));
          var tmp$ret$5 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$5);
          var tmp1_condition = eq(get_project_2(it), $this$remember.baj(this.hf4_1).x7a_1);
          return tmp.feo(new (Query())(tmp1_condition, VOID, VOID, tmp0_limit));
        });
        var tmp_4 = this;
        tmp_4.mf4_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var items = $this$remember.baj($this$remember.baj(this.kf4_1));
          var changes = $this$remember.baj($this$remember.baj(this.lf4_1));
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(items, 10));
          var _iterator__ex2g4s = items.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            // Inline function 'kotlin.collections.filter' call
            // Inline function 'kotlin.collections.filterTo' call
            var destination_0 = ArrayList().w();
            var _iterator__ex2g4s_0 = changes.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var element = _iterator__ex2g4s_0.o1();
              if (element.a6b_1.equals(item.g6k_1)) {
                destination_0.v(element);
              }
            }
            var tmp$ret$13 = AdjustedLineItem().hfy(item, destination_0);
            destination.v(tmp$ret$13);
          }
          return destination;
        });
        var tmp_5 = this;
        tmp_5.nf4_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).ufv_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ScopeView()), arrayOf([]), false));
          var tmp$ret$16 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$16);
          var tmp$ret$20 = eq(get_project_3(it), $this$remember.baj(this.hf4_1).x7a_1);
          return tmp.feo(new (Query())(tmp$ret$20, VOID, VOID, 2147483647));
        });
        var tmp_6 = this;
        tmp_6.of4_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(this.nf4_1)));
        this.pf4_1 = HashMap().n8();
        var tmp_7 = this;
        tmp_7.qf4_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).bfw_1;
          var tmp0_limit = 2147483647;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(PayAppItem()), arrayOf([]), false));
          var tmp$ret$21 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$21);
          var tmp1_condition = eq(get_project_0(it), $this$remember.baj(this.hf4_1).x7a_1);
          return tmp.feo(new (Query())(tmp1_condition, VOID, VOID, tmp0_limit));
        });
        var tmp_8 = this;
        tmp_8.rf4_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj($this$remember.baj(this.qf4_1)));
        var tmp_9 = this;
        tmp_9.sf4_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var this_0 = $this$remember.baj(this.xf4_1);
          var sum = Companion_instance.p91(0n);
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp = sum;
            var tmp$ret$26 = element.qhg_1;
            sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$26);
          }
          var tmp$ret$27 = sum;
          return new (MonetaryValue())(tmp$ret$27);
        });
        var tmp_10 = this;
        tmp_10.tf4_1 = remember(VOID, VOID, VOID, ($this$remember) => new (MonetaryValue())(MonetaryValue__minus_impl_jw9qyp($this$remember.baj(this.hf4_1).s97(), $this$remember.baj(this.sf4_1).a5s_1)));
        var tmp_11 = this;
        tmp_11.uf4_1 = new (PayAppForm$escrowBalanceLimit$1())(this);
        var tmp_12 = this;
        tmp_12.vf4_1 = remember(VOID, true, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.baj(this.rf4_1);
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (!get_status(element).equals(PayAppStatus_Voided_getInstance()) && !get_status(element).equals(PayAppStatus_Denied_getInstance())) {
              destination.v(element);
            }
          }
          var allItems = destination;
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination_0 = ArrayList().w();
          var _iterator__ex2g4s_0 = allItems.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            if (element_0.r6v_1.equals(this.ef4_1)) {
              destination_0.v(element_0);
            }
          }
          var thisDrawItems = destination_0;
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_1 = ArrayList().u(collectionSizeOrDefault(thisDrawItems, 10));
          var _iterator__ex2g4s_1 = thisDrawItems.m1();
          while (_iterator__ex2g4s_1.n1()) {
            var item = _iterator__ex2g4s_1.o1();
            var tmp$ret$34 = item.q6v_1;
            destination_1.v(tmp$ret$34);
          }
          var thisDrawItemsIds = toSet(destination_1);
          var lines = $this$remember.baj(this.mf4_1);
          var project = $this$remember.baj(this.hf4_1);
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_2 = ArrayList().u(collectionSizeOrDefault(thisDrawItems, 10));
          var _iterator__ex2g4s_2 = thisDrawItems.m1();
          while (_iterator__ex2g4s_2.n1()) {
            var item_0 = _iterator__ex2g4s_2.o1();
            // Inline function 'kotlin.collections.find' call
            var tmp$ret$38;
            $l$block: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s_3 = lines.m1();
              while (_iterator__ex2g4s_3.n1()) {
                var element_1 = _iterator__ex2g4s_3.o1();
                if (element_1.kf9_1.equals(item_0.s6v_1)) {
                  tmp$ret$38 = element_1;
                  break $l$block;
                }
              }
              tmp$ret$38 = null;
            }
            var tmp0_elvis_lhs = tmp$ret$38;
            var tmp;
            if (tmp0_elvis_lhs == null) {
              throw NotFound().nfx(getKClass(LineItem()), null);
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var line = tmp;
            var tmp0_0 = this.pf4_1;
            // Inline function 'kotlin.collections.getOrPut' call
            var key = line.kf9_1;
            var value = tmp0_0.p3(key);
            var tmp_0;
            if (value == null) {
              var tmp0_retention = project.u97();
              // Inline function 'kotlin.collections.filter' call
              // Inline function 'kotlin.collections.filterTo' call
              var destination_3 = ArrayList().w();
              var _iterator__ex2g4s_4 = allItems.m1();
              while (_iterator__ex2g4s_4.n1()) {
                var element_2 = _iterator__ex2g4s_4.o1();
                if (!thisDrawItemsIds.t1(element_2.q6v_1) && element_2.s6v_1.equals(line.kf9_1) && !(element_2.u6v_1 == null)) {
                  destination_3.v(element_2);
                }
              }
              // Inline function 'com.crowpay.extensions.sumMoney' call
              var sum = Companion_instance.p91(0n);
              var _iterator__ex2g4s_5 = destination_3.m1();
              while (_iterator__ex2g4s_5.n1()) {
                var element_3 = _iterator__ex2g4s_5.o1();
                var tmp_1 = sum;
                var tmp$ret$43 = element_3.t6v_1;
                sum = MonetaryValue__plus_impl_c1ylt(tmp_1, tmp$ret$43);
              }
              var tmp1_previousPayments = sum;
              // Inline function 'kotlin.collections.filter' call
              // Inline function 'kotlin.collections.filterTo' call
              var destination_4 = ArrayList().w();
              var _iterator__ex2g4s_6 = allItems.m1();
              while (_iterator__ex2g4s_6.n1()) {
                var element_4 = _iterator__ex2g4s_6.o1();
                if (!thisDrawItemsIds.t1(element_4.q6v_1) && element_4.s6v_1.equals(line.kf9_1) && element_4.b6w_1) {
                  destination_4.v(element_4);
                }
              }
              // Inline function 'com.crowpay.extensions.sumMoney' call
              var sum_0 = Companion_instance.p91(0n);
              var _iterator__ex2g4s_7 = destination_4.m1();
              while (_iterator__ex2g4s_7.n1()) {
                var element_5 = _iterator__ex2g4s_7.o1();
                var tmp_2 = sum_0;
                var tmp$ret$48 = element_5.t6v_1;
                sum_0 = MonetaryValue__plus_impl_c1ylt(tmp_2, tmp$ret$48);
              }
              var tmp2_pendingPayments = sum_0;
              var tmp3_escrowBalanceLimit = this.uf4_1;
              var tmp4_reportTo = this.ff4_1;
              var answer = new (PayAppItemForm())(item_0, line, tmp0_retention, tmp1_previousPayments, tmp3_escrowBalanceLimit, tmp2_pendingPayments, tmp4_reportTo);
              tmp0_0.s3(key, answer);
              tmp_0 = answer;
            } else {
              tmp_0 = value;
            }
            var tmp$ret$52 = tmp_0;
            destination_2.v(tmp$ret$52);
          }
          // Inline function 'kotlin.collections.sortedBy' call
          // Inline function 'kotlin.comparisons.compareBy' call
          var tmp_3 = PayAppForm$existingItemForms$lambda$lambda;
          var tmp$ret$55 = new (sam$kotlin_Comparator$0_0())(tmp_3);
          return sortedWith(destination_2, tmp$ret$55);
        });
        var tmp_13 = this;
        tmp_13.wf4_1 = remember(VOID, true, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.baj(this.rf4_1);
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (!get_status(element).equals(PayAppStatus_Voided_getInstance()) && !get_status(element).equals(PayAppStatus_Denied_getInstance())) {
              destination.v(element);
            }
          }
          var allItems = destination;
          var lines = $this$remember.baj(this.mf4_1);
          var project = $this$remember.baj(this.hf4_1);
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination_0 = ArrayList().w();
          var _iterator__ex2g4s_0 = allItems.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            if (element_0.r6v_1.equals(this.ef4_1)) {
              destination_0.v(element_0);
            }
          }
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_1 = ArrayList().u(collectionSizeOrDefault(destination_0, 10));
          var _iterator__ex2g4s_1 = destination_0.m1();
          while (_iterator__ex2g4s_1.n1()) {
            var item = _iterator__ex2g4s_1.o1();
            var tmp$ret$63 = item.s6v_1;
            destination_1.v(tmp$ret$63);
          }
          var existingLineIDs = destination_1;
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination_2 = ArrayList().w();
          var _iterator__ex2g4s_2 = lines.m1();
          while (_iterator__ex2g4s_2.n1()) {
            var element_1 = _iterator__ex2g4s_2.o1();
            if (!existingLineIDs.t1(element_1.kf9_1)) {
              destination_2.v(element_1);
            }
          }
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_3 = ArrayList().u(collectionSizeOrDefault(destination_2, 10));
          var _iterator__ex2g4s_3 = destination_2.m1();
          while (_iterator__ex2g4s_3.n1()) {
            var item_0 = _iterator__ex2g4s_3.o1();
            var tmp0_0 = this.pf4_1;
            // Inline function 'kotlin.collections.getOrPut' call
            var key = item_0.kf9_1;
            var value = tmp0_0.p3(key);
            var tmp;
            if (value == null) {
              var tmp0_item = drawable(item_0.kfy()) ? new (PayAppItem())(VOID, this.ef4_1, item_0.kf9_1, Companion_instance.p91(0n), VOID, VOID, VOID, project.x7a_1) : null;
              var tmp1_retention = project.u97();
              // Inline function 'kotlin.collections.filter' call
              // Inline function 'kotlin.collections.filterTo' call
              var destination_4 = ArrayList().w();
              var _iterator__ex2g4s_4 = allItems.m1();
              while (_iterator__ex2g4s_4.n1()) {
                var element_2 = _iterator__ex2g4s_4.o1();
                if (element_2.s6v_1.equals(item_0.kf9_1) && !(element_2.u6v_1 == null)) {
                  destination_4.v(element_2);
                }
              }
              // Inline function 'com.crowpay.extensions.sumMoney' call
              var sum = Companion_instance.p91(0n);
              var _iterator__ex2g4s_5 = destination_4.m1();
              while (_iterator__ex2g4s_5.n1()) {
                var element_3 = _iterator__ex2g4s_5.o1();
                var tmp_0 = sum;
                var tmp$ret$72 = element_3.t6v_1;
                sum = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$72);
              }
              var tmp2_previousPayments = sum;
              // Inline function 'kotlin.collections.filter' call
              // Inline function 'kotlin.collections.filterTo' call
              var destination_5 = ArrayList().w();
              var _iterator__ex2g4s_6 = allItems.m1();
              while (_iterator__ex2g4s_6.n1()) {
                var element_4 = _iterator__ex2g4s_6.o1();
                if (element_4.s6v_1.equals(item_0.kf9_1) && element_4.b6w_1) {
                  destination_5.v(element_4);
                }
              }
              // Inline function 'com.crowpay.extensions.sumMoney' call
              var sum_0 = Companion_instance.p91(0n);
              var _iterator__ex2g4s_7 = destination_5.m1();
              while (_iterator__ex2g4s_7.n1()) {
                var element_5 = _iterator__ex2g4s_7.o1();
                var tmp_1 = sum_0;
                var tmp$ret$77 = element_5.t6v_1;
                sum_0 = MonetaryValue__plus_impl_c1ylt(tmp_1, tmp$ret$77);
              }
              var tmp3_pendingPayments = sum_0;
              var tmp4_escrowBalanceLimit = this.uf4_1;
              var tmp5_reportTo = this.ff4_1;
              var answer = new (PayAppItemForm())(tmp0_item, item_0, tmp1_retention, tmp2_previousPayments, tmp4_escrowBalanceLimit, tmp3_pendingPayments, tmp5_reportTo);
              tmp0_0.s3(key, answer);
              tmp = answer;
            } else {
              tmp = value;
            }
            var tmp$ret$81 = tmp;
            destination_3.v(tmp$ret$81);
          }
          // Inline function 'kotlin.collections.sortedBy' call
          // Inline function 'kotlin.comparisons.compareBy' call
          var tmp_2 = PayAppForm$missingItemForms$lambda$lambda;
          var tmp$ret$84 = new (sam$kotlin_Comparator$0_1())(tmp_2);
          return sortedWith(destination_3, tmp$ret$84);
        });
        var tmp_14 = this;
        tmp_14.xf4_1 = remember(VOID, true, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.sortedBy' call
          var this_0 = plus_0($this$remember.baj(this.vf4_1), $this$remember.baj(this.wf4_1));
          // Inline function 'kotlin.comparisons.compareBy' call
          var tmp = PayAppForm$allItemForms$lambda$lambda;
          var tmp$ret$86 = new (sam$kotlin_Comparator$0_2())(tmp);
          return sortedWith(this_0, tmp$ret$86);
        });
        var tmp_15 = this;
        tmp_15.yf4_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var this_0 = $this$remember.baj(this.xf4_1);
          var sum = Companion_instance.p91(0n);
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp = sum;
            var tmp_0 = $this$remember.baj(element.uhg_1);
            var tmp0_elvis_lhs = tmp_0 == null ? null : tmp_0.a5s_1;
            var tmp_1;
            var tmp_2 = tmp0_elvis_lhs;
            if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
              tmp_1 = Companion_instance.p91(0n);
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }
            var tmp$ret$88 = tmp_1;
            sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$88);
          }
          var tmp$ret$89 = sum;
          return new (MonetaryValue())(tmp$ret$89);
        });
        var tmp_16 = this;
        tmp_16.zf4_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var this_0 = $this$remember.baj(this.xf4_1);
          var sum = Companion_instance.p91(0n);
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp = sum;
            var tmp$ret$90 = element.shg_1;
            sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$90);
          }
          var tmp$ret$91 = sum;
          return new (MonetaryValue())(MonetaryValue__plus_impl_c1ylt(tmp$ret$91, $this$remember.baj(this.yf4_1).a5s_1));
        });
        var tmp_17 = this;
        tmp_17.af5_1 = Draft(($this$Draft) => toFileData($this$Draft.baj(this.gf4_1).o6y_1));
      }
      ucv() {
        return this.if4_1;
      }
      bhg() {
        return this.jf4_1;
      }
      thh(_this__u8e3s4) {
        if (!get_mainPageNavigator(_this__u8e3s4).qd6()) {
          get_mainPageNavigator(_this__u8e3s4).ebw(new (LandingScreen())());
        }
      }
      th6(_this__u8e3s4) {
        if (get_viewIsNarrow(_this__u8e3s4)) {
          var tmp = get_section(_this__u8e3s4);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())(_this__u8e3s4.pc());
          var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
          var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
          _this__u8e3s4.ebb(p, view);
          view.xbm(false);
          view.zb8(get_AppDimensions().ig2_1);
          view.eba(get_AppDimensions().ig2_1);
          actionBar$deleteButton(view, this);
          var tmp_0 = get_expanding(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (Space())(view.pc());
          var tmp0_elvis_lhs_0 = view.cbb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.ebb(p_0, view_0);
          view.fbb(p_0, view_0);
          view.jbb(tmp_0, view_0);
          actionBar$saveButton(view, this);
          actionBar$submitButton(view, this);
          _this__u8e3s4.fbb(p, view);
          _this__u8e3s4.jbb(tmp, view);
        } else {
          var tmp_1 = get_section(_this__u8e3s4);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(_this__u8e3s4.pc());
          var tmp0_elvis_lhs_1 = _this__u8e3s4.cbb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? _this__u8e3s4 : tmp0_elvis_lhs_1;
          _this__u8e3s4.ebb(p_1, view_1);
          view_1.xbm(false);
          actionBar$saveButton(view_1, this);
          actionBar$saveAndCloseButton(view_1, this);
          actionBar$discardButton(view_1, this);
          actionBar$deleteButton(view_1, this);
          var tmp_2 = get_expanding(view_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (Space())(view_1.pc());
          var tmp0_elvis_lhs_2 = view_1.cbb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
          view_1.ebb(p_2, view_2);
          view_1.fbb(p_2, view_2);
          view_1.jbb(tmp_2, view_2);
          actionBar$submitButton(view_1, this);
          _this__u8e3s4.fbb(p_1, view_1);
          _this__u8e3s4.jbb(tmp_1, view_1);
        }
      }
      rhi(_this__u8e3s4) {
        if (get_viewIsNarrow(_this__u8e3s4))
          renderNarrow(this, _this__u8e3s4);
        else
          renderWide(this, _this__u8e3s4);
      }
    }
    protoOf($).dhg = get_awaitingApprovalMessage;
    protoOf($).ehg = renderFinishRegistration;
    protoOf($).fhg = renderAwaitingApproval;
    protoOf($).ud6 = render;
    initMetadataForClass($, 'PayAppForm', VOID, VOID, [ContractorPage()], [0, 1]);
    PayAppFormClass = $;
  }
  return PayAppFormClass;
}
//region block: exports
export {
  PayAppForm as PayAppForm28kp0pq290pd9,
  CreatePayApp as CreatePayApp1rwu0bqbguotz,
};
//endregion

//# sourceMappingURL=PayAppForm.mjs.map
